MACRAIL = MACRAIL || {};
MACRAIL.weekTypes = {
    standard: 0,
    rail: 1
};
MACRAIL.defaultDatePickerOptions = {
    dateFormat: 'dd/mm/yy',
    showWeek: true,
    calculateWeek: function (date) {
        if (GLOBALS.weekType == MACRAIL.weekTypes.rail) {
            return date.getRailwayWeek();
        }
        else {
            return date.getISOWeek()[1] || '';
        }
    },
    showOtherMonths: 'true',
    selectOtherMonths: 'true',
    changeMonth: true,
    changeYear: true,
    minDate: new Date(2006, 0, 1),
    firstDay: GLOBALS.weekType == MACRAIL.weekTypes.rail ? 6 : 1,
    controlType: ($(window).width() < 700 ? 'select' : 'slider')
};
MACRAIL.defaultSliderOptions = {
    range: "min",
    min: 0,
    max: 100,
    step: 1,
    slide: function (event, ui) {
        var parent = $(this).parent('div.form-group');
        parent.find('input:hidden').val(ui.value);
        parent.find('.slider-value').html(ui.value);
    }
};
var addEvent = window.attachEvent || window.addEventListener;
addEvent('error', function (e) {
    var r = new XMLHttpRequest();
    r.open("POST", "scripts/appreporting.php?task=error", true);
    r.onreadystatechange = function () {
        if (r.readyState != 4 || r.status != 200)
            return;
    };
    var data = {
        "date": (new Date()).getFormatted('Y-m-d H:i:s'),
        "appname": "website",
        "version": "n/a",
        "type": "error",
        "language": "js",
        "message": e.message,
        "url": location.href,
        "line": e.lineno,
        "useragent": navigator.userAgent
    };
    if (e.colno) {
        data.column = e.colno;
    }
    if (e.error) {
        if (e.error.stack) {
            data.stacktrace = e.error.stack;
        }
    }
    var post = JSON.stringify(data);
    r.send(post);
});
$(document).ready(function () {
    var MacRailMenu = (function () {
        var $listItems = $('.menu > ul > li'), $menuItems = $listItems.children('a:not(.normal)'), searchBox = $('#header-search'), searchInput = $('#header-search-input'), searchButton = $('#header-search-button'), searchUrl = $('#header-search-url'), searchToggle = $('.mobile-search-toggle'), menuToggle = $('.mobile-menu-toggle'), searchAjaxDelay = 0, $body = $('body'), current = -1;
        function init() {
            $menuItems.on('click', open);
            $listItems.on('click', function (event) { event.stopPropagation(); });
        }
        function open(event) {
            if (current !== -1) {
                $listItems.eq(current).removeClass('open').children('.sub').slideUp();
            }
            var $item = $(event.currentTarget).parent('li'), idx = $item.index();
            if (current === idx) {
                $item.removeClass('open').children('.sub').slideUp();
                current = -1;
            }
            else {
                $item.addClass('open').children('.sub').slideDown();
                current = idx;
                $body.off('click').on('click', close);
                if ($(window).width() > 768)
                    $(document).on('scroll', close);
            }
            return false;
        }
        function close(event) {
            $listItems.eq(current).removeClass('open');
            $listItems.eq(current).children('.sub').slideUp();
            current = -1;
        }
        function hideSearch() {
            if (searchInput.val() != '') {
                return;
            }
            setTimeout(function () {
                searchInput.blur();
            }, 300);
        }
        searchBox.on('click', function (e) {
            e.stopPropagation();
        });
        function searchDoAjax() {
            if (searchInput.val().length <= 3)
                return false;
            $('#menu-search-results').html('<div class="menu-search-loading-text">Searching for Events...</div>');
            $('#menu-search-results').load('ajax/menu-search.php', { search: searchInput.val() });
            LogAction([{
                    type: 'Search',
                    task: 'Menu Search',
                    item: searchInput.val()
                }][0]);
            if ($('#menu-search').children('.sub').css("display") == "none") {
                $('#menu-search').show().children('a').trigger('click');
            }
        }
        searchInput.on('keyup', function (e) {
            var code = e.keyCode || e.which;
            clearTimeout(searchAjaxDelay);
            if (code == 13 && ($(window).width() <= 900 || $("html").hasClass("ie7"))) {
                location.href = searchUrl.val() + '&item=' + searchInput.val();
                return false;
            }
            if (!$(window).width() <= 900) {
                searchAjaxDelay = setTimeout(searchDoAjax, 800);
            }
        });
        searchInput.on('keydown', function (e) {
            clearTimeout(searchAjaxDelay);
        });
        searchButton.on('click', function (e) {
            if ($(window).width() > 900 && !$("html").hasClass("ie7")) {
                searchDoAjax();
            }
            else {
                location.href = searchUrl.val() + '&item=' + searchInput.val();
            }
        });
        searchToggle.on('click', function (e) {
            searchBox.toggleClass('active');
            searchToggle.toggleClass('active');
        });
        menuToggle.on('click', function (e) {
            $('#menu').toggleClass('active');
            menuToggle.toggleClass('active');
        });
        $(document).on('click', function (e) {
            searchInput.val('');
            hideSearch();
        });
        return { init: init };
    })();
    MacRailMenu.init();
    $('.forceuppercase')
        .on('input', function () {
        if (this.value.length > 0) {
            this.style.textTransform = 'uppercase';
        }
        else {
            this.style.textTransform = '';
        }
    })
        .on('change', function () {
        this.value = this.value.toLocaleUpperCase();
    });
    $('.autoselectbrackets').on('mouseup tap', function () {
        var selStart = this.selectionStart;
        var selEnd = this.selectionEnd;
        var newStart = -1;
        var newEnd = -1;
        if (selStart == selEnd) {
            for (var i = 1; i < 35; i++) {
                if (this.value.charAt(selStart - i) == ']')
                    break;
                if (this.value.charAt(selStart - i) == '[') {
                    newStart = selStart - i;
                    break;
                }
            }
            for (var i = 0; i < 35; i++) {
                if (this.value.charAt(selEnd + i) == '[')
                    break;
                if (this.value.charAt(selEnd + i) == ']') {
                    newEnd = selEnd + i + 1;
                    break;
                }
            }
            if (newStart != -1 && newEnd != -1) {
                this.selectionStart = newStart;
                this.selectionEnd = newEnd;
            }
        }
    });
    var $stickyElements = $('.sticky-element');
    $stickyElements.each(function (i, el) {
        var $element = $(el);
        var $parent = $element.parent();
        var elementHeight = $element.outerHeight(true);
        var placeHolder = $('<div />').insertAfter($element);
        var shouldStickOld = false;
        var bottomPosOld = 0;
        function calcStickiness() {
            var scrollPos = $(window).scrollTop();
            var viewportHeight = $(window).height();
            var placeHolderPos = placeHolder.offset().top;
            var pos = (placeHolderPos + placeHolder.height()) - scrollPos - viewportHeight;
            var shouldStick = pos > 0;
            var bottomPos = Math.min(0, viewportHeight - ($parent.offset().top - scrollPos) - 200);
            if (bottomPos != bottomPosOld) {
                $element.css({
                    bottom: bottomPos + 'px'
                });
                bottomPosOld = bottomPos;
            }
            if (shouldStick) {
                $element.css({ width: $element.parent().css('width') });
            }
            if (shouldStick != shouldStickOld) {
                shouldStickOld = shouldStick;
                if (shouldStick) {
                    placeHolder.css({
                        height: elementHeight + 'px',
                    });
                    $element.addClass('sticky-element-stuck');
                }
                else {
                    placeHolder.css({ height: '' });
                    $element.removeClass('sticky-element-stuck');
                    $element.css({ width: '' });
                }
            }
        }
        $(document).on('scroll', calcStickiness);
        $(window).on('resize', calcStickiness);
        calcStickiness();
    });
    $(document).on("mouseenter", '[data-toggle="popover"]', function (e) {
        $(this).popover({ trigger: 'click', html: true });
    });
    $(document).on("mouseenter", '[data-toggle="tooltip"]', function (e) {
        if ($(this).hasClass('diary-timeline-entry')) {
            if ('ontouchstart' in document.documentElement) {
                e.preventDefault();
            }
        }
        $(this).tooltip({ html: true }).tooltip('show');
    });
    $('body').on('click', function (e) {
        $('[data-toggle="popover"]').each(function () {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });
    $(document).on('change', '.btn-file :file', function () {
        var input = $(this), numFiles = input.get(0).files ? input.get(0).files.length : 1, label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        input.trigger('fileselect', [numFiles, label]);
    });
    $('.btn-file :file').on('fileselect', function (event, numFiles, label) {
        var input = $(this).parents('.input-group').find(':text'), log = numFiles > 1 ? numFiles + ' files selected' : label;
        if (input.length) {
            input.val(log);
        }
        else {
            if (log)
                alert(log);
        }
    });
    $(document).on('click', '.picture-modal', function () {
        if ($('#pictureModal').length)
            $('#pictureModal').remove();
        createModalTemplate('pictureModal', {
            Title: $(this).attr('title') || 'Picture'
        });
        var src = $(this).attr('data-fullurl');
        if (src == undefined || src == '') {
            src = $(this).attr('href');
        }
        var description = $(this).attr('data-desc') || '';
        $('#pictureModal .modal-content').append('<div class="modal-body"><div style="text-align:center;"><img style="max-width:100%;" src="' + src + '"></div><p style="margin:0;">' + description + '</p></div>');
        $('#pictureModal').modal({ keyboard: true, backdrop: "static" }).modal('show');
        return false;
    });
    $(document).on('click', '.phoneqrcode', function (e) {
        $this = $(this);
        $content = $('<div>If you have a mobile with a QR-Code scanner, scan the below code to call the person.<br /><br /><div></div></div>');
        var qrcode = new QRCode($content.find('div')[0], {
            text: $this.parent().find('a').attr('href'),
            width: 180,
            height: 180,
            colorDark: "#123",
            colorLight: "#fff",
            correctLevel: QRCode.CorrectLevel.L
        });
        $this.qtip({
            content: {
                text: $content
            },
            style: {
                classes: 'qtip-light qtip-shadow',
                width: '200px'
            },
            position: {
                my: 'top middle',
                at: 'bottom middle',
                adjust: {
                    y: 5
                }
            },
            show: {
                event: false,
                when: false,
                ready: true
            },
            hide: 'unfocus'
        });
    });
    function toggleChevron(e) {
        $(e.target).prev('.panel-heading').find('a[data-toggle="collapse"] .fa').toggleClass('fa-chevron-down fa-chevron-up');
    }
    $('body').on('hidden.bs.collapse', '.panel-group', toggleChevron);
    $('body').on('shown.bs.collapse', '.panel-group', toggleChevron);
    $(document).on('click', '.autoselectcontent', function () {
        var range, selection;
        if (document.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(this);
            range.select();
        }
        else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(this);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    });
    $(document).ready(function ($) {
        if ($(window).width() > 768) {
            var offset = 300, scroll_top_duration = 700, $back_to_top = $('.to-top-link');
            $(window).scroll(function () {
                ($(this).scrollTop() > offset) ? $back_to_top.addClass('to-top-link-visible') : $back_to_top.removeClass('to-top-link-visible');
            });
            $back_to_top.on('click', function (event) {
                event.preventDefault();
                $('body,html').animate({ scrollTop: 0 }, scroll_top_duration);
            });
        }
    });
    $('body').on('click', '.create-help', function () {
        var parameters = [{
                type: 1,
                task: $(this).attr('data-help'),
                item: $(this).attr('data-element'),
                event: $(this).attr('data-event'),
                user: $(this).attr('data-user'),
                show: $(this).attr('data-show'),
                multiHelp: $(this).attr('data-multiple'),
                multiItems: $(this).attr('data-mutltipleitems'),
                content: parseFloat($(this).attr('data-version')),
                userversion: parseFloat($(this).attr('data-userversion')),
                version: parseFloat($(this).attr('data-version'))
            }];
        parameters = parameters[0];
        JSLoading('assetlibs/introjs/intro.js', function () { getHelpGuide(parameters); });
    });
    if ($('#product-update-button').length) {
        window.announcekit = (window.announcekit || { queue: [], on: function (n, x) {
                window.announcekit.queue.push([n, x]);
            }, push: function (x) { window.announcekit.queue.push(x); }
        });
        var announcekitLabels = [
            "Worksite360",
        ];
        var announceKitElement = $('.announcekit-widget');
        var info = JSON.parse(announceKitElement.attr('data-info'));
        var data = Object.assign({
            "widget": "https://announcekit.co/widgets/v2/" + announceKitElement.attr('data-id'),
            "selector": ".announcekit-widget",
            badge: {
                style: {
                    'width': '1em',
                    'height': '1em',
                    'position': 'absolute',
                    'vertical-align': 'middle',
                    'visibility': 'visible',
                    'font-size': '20px',
                    'top': '0',
                    'right': '0'
                }
            }
        }, info);
        window.announcekit.push(data);
    }
    toolbarResizing();
    var resizeId;
    $(window).resize(function () {
        clearTimeout(resizeId);
        resizeId = setTimeout(toolbarResizing, 100);
    });
    $('.recognise').each(function () {
        var $this = $(this);
        var postCodeRegex = /(((([A-PR-UWYZ][A-HK-Y]?[0-9][0-9]?)|(([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRV-Y]))) [0-9][ABD-HJLNP-UW-Z]{2}))/g;
        $this.html($this.html().replace(postCodeRegex, '<span class="recognise-item recognise-type-postcode">$&</span>'));
    });
    $(document).on('click', '.recognise-item', function () {
        var $this = $(this);
        var postCode = $this.text();
        var imageScale = window.devicePixelRatio < 1.5 ? 1 : 2;
        var mapsUrl = 'https://maps.google.com?q=' + postCode;
        var modal = $this.data('recognise-modal');
        if (modal == undefined) {
            modal = new MACRAIL.Modal({
                buttons: [{
                        'name': 'close',
                        'role': 'dismiss',
                        'text': 'Close',
                    }],
                title: 'Map for ' + postCode,
                body: '<img src="https://maps.googleapis.com/maps/api/staticmap?key=' + PAGEVARS.GoogleApiKeyStaticMaps + '&size=570x420&zoom=12&scale=' + imageScale + '&markers=color:red|' + encodeURIComponent(postCode) + '" style="max-width: 570px;" /><br /><br /><a href="' + mapsUrl + '" target="_blank">Open in Google Maps</a>'
            });
            $this.data('recognise-modal', modal);
        }
        modal.show();
    });
    $('body').on('input blur', 'input.price', function () {
        var val = $(this).val();
        $(this).val(val.replace(/[^\d.,]/g, ''));
    });
});
function parseHelpJson(response, object) {
    var content = $.grep(response, function (obj, index) {
        if (object.show === 'new' || object.show === 'multi-new') {
            obj.intro = '<p style="font-size:12pt"><strong>New!</strong></p>' + obj.intro;
            return (obj.version > object.userversion);
        }
        if (object.item !== undefined) {
            if (obj.parent !== undefined && obj.parent == object.item) {
                return ($(obj.element).length && $(obj.element).is(':visible'));
            }
            else {
                return (object.item === obj.element && $(obj.element).length && $(obj.element).is(':visible'));
            }
        }
        else {
            return (typeof obj.element == 'undefined') || ($(obj.element).length && $(obj.element).is(':visible'));
        }
    });
    return content;
}
function getHelpGuide(parameters) {
    if (parameters.multiHelp == 1) {
        parameters.content = '';
        var userObj = $.parseJSON(parameters.multiItems);
        var requests = [];
        var helpObjects = [];
        $.each(userObj, function (key, value) {
            var path = 'pieces/tours/' + value.name + '.json';
            helpObjects.push({
                show: parameters.show,
                userversion: parseFloat(value.userVersion),
                version: parseFloat(value.helpVersion)
            });
            requests.push($.getJSON(path));
            if (parameters.show === 'multi-new' || parameters.show === 'multi-all') {
                $.post('ajax/user-meta.php', {
                    type: value.name,
                    user: parameters.user,
                    value: value.helpVersion
                });
            }
        });
        $.when.apply(null, requests).then(function () {
            var returnedData = [];
            $.each(arguments, function (i, row) {
                var status = row[1], data = row[0];
                if (status === 'success') {
                    if (parseFloat(helpObjects[i].userversion) == parseFloat(helpObjects[i].version) && parameters.show === 'multi-all') {
                        return;
                    }
                    var content = parseHelpJson(data, helpObjects[i]);
                    if (!content.length) {
                        return false;
                    }
                    if (parameters.item !== undefined && content[0].subtour != undefined) {
                        $.each(content[0].subtour, function (key, value) {
                            content.push(value);
                        });
                    }
                    returnedData = $.merge(returnedData, content);
                }
            });
            if (!returnedData.length) {
                return false;
            }
            runHelp(parameters, returnedData);
        });
    }
    else {
        var path = 'pieces/tours/' + parameters.task + '.json';
        var returnedData = [];
        $.getJSON(path, function (response) {
            returnedData = parseHelpJson(response, parameters);
            if (!returnedData.length) {
                return false;
            }
            if (parameters.show === 'new' || parameters.show === 'all') {
                $.post('ajax/user-meta.php', {
                    type: parameters.task,
                    user: parameters.user,
                    value: parameters.version
                });
            }
            if (parameters.item !== undefined && returnedData[0].subtour != undefined) {
                $.each(returnedData[0].subtour, function (key, value) {
                    returnedData.push(value);
                });
            }
            if (!returnedData.length) {
                return false;
            }
            runHelp(parameters, returnedData);
        });
    }
}
function runHelp(parameters, returnedData) {
    var guide = introJs();
    guide.setOptions({
        steps: returnedData,
        showBullets: returnedData.length > 1 ? true : false,
        showStepNumbers: returnedData.length > 1 ? true : false,
        scrollToElement: false,
        disableInteraction: true,
        tooltipPosition: 'auto'
    });
    var exit = (exit == undefined ? false : exit);
    var complete = (complete == undefined ? false : complete);
    guide.oncomplete(function () {
        if (!complete) {
            parameters.status = 'completed';
            LogAction(parameters);
            complete = true;
        }
    });
    guide.onexit(function () {
        if (!exit && !complete) {
            parameters.status = 'quit';
            LogAction(parameters);
            exit = true;
        }
    });
    guide.start();
}
function LogAction(parameters) {
    $.post('ajax/user-action.php', {
        user: (parameters.user === undefined ? null : parameters.user),
        type: parameters.type,
        task: parameters.task,
        item: (parameters.item === undefined ? null : parameters.item),
        status: (parameters.status === undefined ? null : parameters.status),
        event: (parameters.event === undefined ? null : parameters.event),
        content: (parameters.content === undefined ? null : parameters.content),
    });
}
function toolbarResizing() {
    var windowwidth = $(window).width();
    if ($('.macrail-toolbar-normal').length == 0)
        return true;
    $('.macrail-toolbar-normal').each(function () {
        var toolbar = $(this), toolbarid = $(this).attr('id'), toolbargroups = toolbar.find('.btn-group').not('.macrail-toolbar-toggle'), grouptotal = toolbar.attr('data-groups'), mobilemenutoggle = toolbar.find('.macrail-toolbar-toggle'), mobilemenu = $('#' + toolbarid + '-mobile'), mobilemenulinks = mobilemenu.children().length, hiddenlinks = 0;
        if (!toolbar.attr('data-mobile') && windowwidth > 768) {
            return true;
        }
        if (mobilemenulinks == 0 && windowwidth <= 768) {
            $(toolbargroups).children('.macrail-toolbar-desktop').each(function () {
                var link = $(this), copy = link.clone(), list = $('<li>');
                link.addClass('btn-hidden');
                copy.removeClass().removeAttr('style');
                list.append(copy);
                list.appendTo($('#' + toolbarid + '-mobile'));
                hiddenlinks++;
            });
        }
        if ((mobilemenulinks > 0 || hiddenlinks > 0) && windowwidth <= 768) {
            $(toolbar).attr('data-mobile', true);
            $(mobilemenutoggle).addClass('active');
        }
        $(toolbargroups).not('.btn-group-justified').each(function () {
            var group = $(this), childlinks = parseInt(group.attr('data-buttons')), hiddenlinks = group.find('.btn-hidden').length;
            if (windowwidth <= 768) {
                if (hiddenlinks === childlinks) {
                    group.hide();
                }
                var button = (childlinks - hiddenlinks);
                group.find('.button-' + childlinks).removeClass('button-' + childlinks).addClass('button-' + button);
                group.attr('data-buttons-mobile', button);
                toolbar.find('.btn-group').filter(':visible').css('width', 100 / toolbar.find('.btn-group').filter(':visible').not('.btn-group-justified').length + '%');
            }
            else {
                group.show();
                group.css('width', '');
                if (group.hasClass('btn-group-justified')) {
                    group.css('display', '');
                    return true;
                }
                var mobile = group.attr('data-buttons-mobile');
                group.find('.button-' + mobile).removeClass('button-' + mobile).addClass('button-' + childlinks);
            }
        });
    });
}
;
function createDate(sqldate) {
    var d = new String(sqldate);
    d = d.replace(/[^0-9]/g, ' ');
    d = d.split(' ');
    if (d.length == 5) {
        d[5] = 0;
    }
    if (d[2] > 40) {
        var temp = d[0];
        d[0] = d[2];
        d[2] = temp;
    }
    return new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5]);
}
Date.prototype.getISOWeek = function () {
    var date = this;
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return [d.getUTCFullYear(), weekNo];
};
Date.prototype.getRailwayWeek = function () {
    var _a, _b;
    var date = this;
    const ANCHORS = {
        2020: [2020, 3, 4, 0, 0, 0],
        2026: [2026, 3, 4, 0, 0, 0],
    };
    const y = date.getFullYear();
    const a = (_a = ANCHORS[y]) !== null && _a !== void 0 ? _a : [y, 2, 28, 0, 0, 0];
    let sat = new Date(...a);
    sat.setDate(sat.getDate() + ((6 - sat.getDay() + 7) % 7));
    if (sat > date) {
        const py = y - 1;
        const pa = (_b = ANCHORS[py]) !== null && _b !== void 0 ? _b : [py, 2, 28, 0, 0, 0];
        sat = new Date(...pa);
        sat.setDate(sat.getDate() + ((6 - sat.getDay() + 7) % 7));
    }
    var diff = date.getTime() - sat.getTime();
    diff = Math.round(diff / 86400000 / 7) + 1;
    return diff;
};
Date.prototype.getFormatted = function (text) {
    var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'];
    var ordinals = ['', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th', 'th',
        'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th', 'th',
        'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th', 'th',
        'st'];
    var result = '';
    var char;
    for (var i = 0; i < text.length; i++) {
        char = text.substr(i, 1);
        switch (char) {
            case '\\':
                i++;
                char = text.substr(i, 1);
                break;
            case 'j':
                char = this.getDate();
                break;
            case 'd':
                char = ((this.getDate() < 10 ? '0' : '') + this.getDate()).substr(-2);
                break;
            case 'D':
                char = dayNames[this.getDay()].substr(0, 3);
                break;
            case 'l':
                char = dayNames[this.getDay()];
                break;
            case 'N':
                char = '#';
                break;
            case 'S':
                char = ordinals[this.getDate()];
                break;
            case 'w':
                char = this.getDay();
                break;
            case 'z':
                char = '#';
                break;
            case 'W':
                char = '#';
                break;
            case 'F':
                char = monthNames[this.getMonth()];
                break;
            case 'm':
                char = (((this.getMonth() + 1) < 10 ? '0' : '') + (this.getMonth() + 1)).substr(-2);
                break;
            case 'M':
                char = monthNames[this.getMonth()].substr(0, 3);
                break;
            case 'n':
                char = this.getMonth() + 1;
                break;
            case 't':
                char = '#';
                break;
            case 'L':
                char = '#';
                break;
            case 'o':
                char = '#';
                break;
            case 'Y':
                char = this.getFullYear();
                break;
            case 'y':
                char = this.getFullYear().toString().substr(2);
                break;
            case 'a':
                char = '#';
                break;
            case 'A':
                char = '#';
                break;
            case 'B':
                char = '#';
                break;
            case 'g':
                char = '#';
                break;
            case 'G':
                char = this.getHours();
                break;
            case 'h':
                char = '#';
                break;
            case 'H':
                char = ((this.getHours() < 10 ? '0' : '') + this.getHours()).substr(-2);
                break;
            case 'i':
                char = ((this.getMinutes() < 10 ? '0' : '') + this.getMinutes()).substr(-2);
                break;
            case 's':
                char = ((this.getSeconds() < 10 ? '0' : '') + this.getSeconds()).substr(-2);
                break;
            case 'u':
                char = ((this.getMilliseconds() < 10 ? '00' : '') + this.getMilliseconds()).substr(-3);
                break;
            case 'e':
                char = '#';
                break;
            case 'I':
                char = '#';
                break;
            case 'O':
                char = '#';
                break;
            case 'P':
                char = '#';
                break;
            case 'T':
                char = '#';
                break;
            case 'Z':
                char = '#';
                break;
            case 'c':
                char = this.getFormatted('Y-m-d\\TH:i:sP');
                break;
            case 'r':
                char = this.getFormatted('D, j M Y H:i:s O');
                break;
            case 'U':
                char = this.getTime();
                break;
        }
        result += char;
    }
    return result;
};
function setFieldValue(id, value) {
    var field = $('#' + id);
    var oldValue = field.val();
    field.val(value);
    if (field.is('select') && field.val() == null) {
        field.val(oldValue);
        alert('Sorry - the field cannot be set to that value. Perhaps that item is no longer available (e.g. a Company has now been deleted).');
        return false;
    }
    field.trigger('change');
    return false;
}
function createModalTemplate(id, attr) {
    attr = $.extend({
        DialogSize: '',
        HeaderClass: '',
        Title: '',
        ShowClose: true,
        Container: $('#content-container')
    }, attr || {});
    if ($('#' + id).length > 0) {
        $('#' + id + ' .modal-title').html(attr.Title);
        $('#' + id + ' .modal-body').remove();
        $('#' + id + ' .modal-footer').remove();
        return;
    }
    var modal = $('<div>').attr({ id: id, tabindex: '-1', role: 'dialog', 'aria-labelledby': id, 'aria-hidden': true }).addClass('modal fade'), dialog = $('<div>').addClass('modal-dialog ' + attr.DialogSize), content = $('<div>').addClass('modal-content'), header = $('<div>').addClass('modal-header ' + attr.HeaderClass), title = $('<h4>').addClass('modal-title').html(attr.Title), closeButton = $('<button>').attr({ type: 'button', 'data-dismiss': "modal", 'aria-hidden': true }).addClass('close').html('<i class="fa fa-times"></i>');
    if (attr.ShowClose)
        header.append(closeButton);
    header.append(title);
    content.append(header);
    dialog.append(content);
    modal.append(dialog);
    attr.Container.append(modal);
}
function setModalAlert(id, className, html) {
    var $modal = $('#' + id);
    var $modalBody = $modal.find('.modal-body');
    var $modalAlert = $modalBody.find('.modal-alert');
    if ($modalAlert.length == 0) {
        $modalBody.prepend('<div class="modal-alert alert" style="margin-bottom: 15px;"></div>');
        $modalAlert = $modalBody.find('.modal-alert');
    }
    $modalAlert.prop('class', 'modal-alert alert alert-' + className);
    $modalAlert.html(html);
}
jQuery.fn.setAlertClass = function (className) {
    var alertClasses = 'alert-default alert-info alert-success alert-warning alert-danger alert-primary alert-secondary';
    var btnClasses = 'btn-default btn-info btn-success btn-warning btn-danger btn-primary btn-secondary';
    var highlightClasses = 'highlight-default highlight-info highlight-success highlight-warning highlight-danger highlight-primary highlight-secondary';
    this.removeClass(alertClasses).addClass('alert-' + className);
    var button = this.find('.alert-button');
    if (button.length > 0) {
        button.removeClass(btnClasses).addClass('btn-' + className);
    }
    var highlight = this.find('.highlight');
    if (highlight.length > 0) {
        highlight.removeClass(highlightClasses).addClass('highlight-' + className);
    }
    return this;
};
function JSLoading(path, callback) {
    var exists = document.querySelector("script[src*='" + path + "']");
    if (exists === null) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = path;
        script.onreadystatechange = function () {
            if (this.readyState == 'complete' || this.readyState == 'loaded') {
                if (callback instanceof Function) {
                    callback();
                }
            }
        };
        script.addEventListener('load', function () {
            if (callback instanceof Function) {
                setTimeout(() => {
                    callback();
                }, 0);
            }
        });
        document.body.appendChild(script);
    }
    else {
        if (callback instanceof Function) {
            callback();
        }
    }
}
var MACRAIL;
(function (MACRAIL) {
    var Ajax;
    (function (Ajax) {
        function getAction(action, params) {
            return this.callAction('GET', action, params);
        }
        Ajax.getAction = getAction;
        function postAction(action, params) {
            return this.callAction('POST', action, params);
        }
        Ajax.postAction = postAction;
        function callAction(method, action, params) {
            let request = {
                'type': method,
                'url': MACRAIL.Helpers.makeUrl({ 'action': action }),
                'data': params,
            };
            return $.ajax(request);
        }
        Ajax.callAction = callAction;
        function getController(controller, action, params) {
            return this.callController('GET', controller, action, params);
        }
        Ajax.getController = getController;
        function postController(controller, action, params) {
            return this.callController('POST', controller, action, params);
        }
        Ajax.postController = postController;
        function callController(method, controller, action, params) {
            let request = {
                'type': method,
                'url': MACRAIL.Helpers.makeUrl({
                    'controller': controller,
                    'action': action,
                }),
                'data': params,
            };
            return $.ajax(request);
        }
        Ajax.callController = callController;
        function getScript() {
        }
        Ajax.getScript = getScript;
    })(Ajax = MACRAIL.Ajax || (MACRAIL.Ajax = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    let AlertClass;
    (function (AlertClass) {
        AlertClass["Primary"] = "primary";
        AlertClass["Secondary"] = "secondary";
        AlertClass["Info"] = "info";
        AlertClass["Success"] = "success";
        AlertClass["Warning"] = "warning";
        AlertClass["Danger"] = "danger";
    })(AlertClass = MACRAIL.AlertClass || (MACRAIL.AlertClass = {}));
    class Alert {
        constructor(element) {
            this.element = $(element);
            this.contentElement = this.element.find('.alert-content');
        }
        setText(text) {
            this.contentElement.text(text);
            return this;
        }
        setHtml(html) {
            this.contentElement.html(html);
            return this;
        }
        setClass(className) {
            this.element.setAlertClass(className);
            return this;
        }
        show() {
            this.element.removeClass('hide');
            return this;
        }
        hide() {
            this.element.addClass('hide');
            return this;
        }
    }
    MACRAIL.Alert = Alert;
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    let ConfirmAlertState;
    (function (ConfirmAlertState) {
        ConfirmAlertState["NotApplicable"] = "notapplicable";
        ConfirmAlertState["Unconfirmed"] = "unconfirmed";
        ConfirmAlertState["Confirmed"] = "confirmed";
    })(ConfirmAlertState = MACRAIL.ConfirmAlertState || (MACRAIL.ConfirmAlertState = {}));
    class ConfirmAlert {
        constructor(element) {
            this.element = $(element);
            this.contentElement = this.element.find('.alert-content');
            this.confirmButton = this.element.find('.alert-button');
            this.confirmButton.on('click', () => {
                this.setState(ConfirmAlertState.Confirmed);
            });
        }
        setText(text) {
            this.contentElement.text(text);
        }
        setHtml(html) {
            this.contentElement.html(html);
        }
        setClass(className) {
            this.element.setAlertClass(className);
        }
        getState() {
            return this.state;
        }
        setState(state) {
            if (this.state === state) {
                return;
            }
            this.state = state;
            this.element.removeClass('state-notapplicable state-unconfirmed state-confirmed');
            this.element.addClass('state-' + state);
            this.element.trigger('confirmalert-statechange');
        }
    }
    MACRAIL.ConfirmAlert = ConfirmAlert;
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    class EventEmitter {
        constructor() {
            this.eventListeners = {};
        }
        on(eventName, callbackOrFilter, callback) {
            if (!this.eventListeners[eventName]) {
                this.eventListeners[eventName] = {
                    'callbacks': [],
                    'filteredCallbacks': {},
                };
            }
            if (typeof callbackOrFilter === 'function') {
                this.eventListeners[eventName].callbacks.push(callbackOrFilter);
            }
            else {
                if (!this.eventListeners[eventName].filteredCallbacks[callbackOrFilter]) {
                    this.eventListeners[eventName].filteredCallbacks[callbackOrFilter] = [];
                }
                this.eventListeners[eventName].filteredCallbacks[callbackOrFilter].push(callback);
            }
        }
        trigger(eventName, filterOrData, data) {
            if (!this.eventListeners[eventName]) {
                return;
            }
            if (filterOrData === undefined || typeof filterOrData === 'object') {
                for (let callback of this.eventListeners[eventName].callbacks) {
                    callback(filterOrData);
                }
            }
            else {
                if (!this.eventListeners[eventName].filteredCallbacks[filterOrData]) {
                    return;
                }
                for (let callback of this.eventListeners[eventName].filteredCallbacks[filterOrData]) {
                    callback(data);
                }
            }
        }
    }
    MACRAIL.EventEmitter = EventEmitter;
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Helpers;
    (function (Helpers) {
        function createQtip(opts) {
            let position = {
                'adjust': {
                    'method': 'shift',
                },
                'target': opts.target,
            };
            switch (opts.position) {
                case 'above':
                    position.my = 'bottom center';
                    position.at = 'top center';
                    break;
                case 'below':
                    position.my = 'top center';
                    position.at = 'bottom center';
                    break;
                case 'left':
                    position.my = 'right center';
                    position.at = 'left center';
                    break;
                case 'right':
                    position.my = 'left center';
                    position.at = 'right center';
                    break;
            }
            if (!opts.class) {
                opts.class = 'default';
            }
            if (opts.extraClasses) {
                opts.extraClasses = ' ' + opts.extraClasses;
            }
            else {
                opts.extraClasses = '';
            }
            let tipWidth = 11;
            if (opts.position === 'above' || opts.position === 'below') {
                tipWidth = 11;
            }
            let target = $(opts.target);
            target.qtip({
                'content': {
                    'title': opts.title || '',
                    'text': opts.content || '',
                },
                'style': {
                    'classes': 'qtip-macrail qtip-' + opts.class + opts.extraClasses,
                    'tip': {
                        'corner': true,
                        'height': 7,
                        'width': tipWidth,
                    },
                },
                'position': position,
                'show': {
                    'event': opts.event || false,
                    'ready': false,
                },
                'hide': {
                    'event': 'unfocus',
                },
            });
            return target.qtip('api');
        }
        Helpers.createQtip = createQtip;
        function makeUrl(opts) {
            let params = {};
            if (opts.eventId) {
                params.e = opts.eventId;
            }
            else if (GLOBALS.hasEvent) {
                params.e = GLOBALS.eventId;
            }
            params.com = opts.controller || GLOBALS.controller;
            if (params.com.substr(0, 3) !== 'com') {
                params.com = 'com' + params.com;
            }
            if (opts.action) {
                params.task = opts.action;
            }
            else if (GLOBALS.action) {
                params.task = GLOBALS.action;
            }
            if (opts.item) {
                params.item = opts.item;
            }
            $.extend(params, opts.params);
            return GLOBALS.siteUrl + 'index.php?' + $.param(params);
        }
        Helpers.makeUrl = makeUrl;
        function escapeHtml(text) {
            return text
                .replace(/&/g, '&amp;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        }
        Helpers.escapeHtml = escapeHtml;
        function formatDuration(time1, time2, opts) {
            if (time1.getTime) {
                time1 = time1.getTime();
            }
            let duration = 0;
            if (time2) {
                if (time2.getTime) {
                    time2 = time2.getTime();
                }
                duration = time2 - time1;
            }
            else {
                duration = time1;
                opts = time2;
            }
            opts = opts || {};
            opts.format = opts.format || 'short';
            opts.includeZero = opts.includeZero || false;
            if (isNaN(duration)) {
                return undefined;
            }
            duration /= 1000;
            let hours = Math.floor(duration / 3600);
            let mins = Math.floor((duration % 3600) / 60);
            let h = 'h';
            let m = 'm';
            if (opts.format === 'long') {
                h = ' hour' + (hours === 1 ? '' : 's');
                m = ' minute' + (mins === 1 ? '' : 's');
            }
            if (opts.includeZero) {
                return hours + h + ' ' + mins + m;
            }
            else {
                if (hours === 0) {
                    return mins + m;
                }
                else if (mins === 0) {
                    return hours + h;
                }
                else {
                    return hours + h + ' ' + mins + m;
                }
            }
        }
        Helpers.formatDuration = formatDuration;
        function formatRelativeTime(time, now) {
            if (!now) {
                now = new Date();
            }
            let text = time.getFormatted('H:i');
            let diffSeconds = Math.abs(Math.round((now.getTime() - time.getTime()) / 1000));
            let days = Math.floor(diffSeconds / 86400);
            let hours = Math.floor((diffSeconds % 86400) / 3600);
            let minutes = Math.floor((diffSeconds % 3600) / 60);
            let seconds = diffSeconds % 60;
            let before = time.getTime() < now.getTime();
            let html = '';
            if (days > 14) {
                html = `${days}d`;
            }
            else if (days > 0) {
                html = `${days}d ${hours}h`;
            }
            else {
                let diff = Math.abs(Math.round((diffSeconds) / (3600 / 4)));
                let fracs = ['', '<sup>1</sup>⁄<sub>4</sub>', '<sup>1</sup>⁄<sub>2</sub>', '<sup>3</sup>⁄<sub>4</sub>'];
                if (diff === 0) {
                    html = 'now';
                }
                else if (diff <= 3) {
                    html = fracs[diff % 4] + ' hr';
                }
                else if (diff <= 4) {
                    html = '1 hr';
                }
                else {
                    html = Math.floor(diff / 4) + ' ' + fracs[diff % 4] + ' hrs';
                }
            }
            if (html !== 'now') {
                if (before) {
                    html = html + ' ago';
                }
                else {
                    html = 'in ' + html;
                }
            }
            return html;
        }
        Helpers.formatRelativeTime = formatRelativeTime;
        function parseQueryString(queryString) {
            if (queryString === undefined) {
                queryString = location.search;
            }
            let params = {};
            queryString.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, key, value) { params[key] = value; return ''; });
            return params;
        }
        Helpers.parseQueryString = parseQueryString;
        function setQueryString(url, params) {
            if (typeof (url) !== 'string') {
                params = url;
                url = document.location.href;
            }
            let currentParams = this.parseQueryString(url);
            let newParams = $.extend({}, currentParams, params);
            if (url.indexOf('?') > -1) {
                url = url.substr(0, url.indexOf('?'));
            }
            let urlParts = [];
            for (let prop in newParams) {
                if (!newParams.hasOwnProperty(prop)) {
                    continue;
                }
                urlParts.push(prop + '=' + encodeURIComponent(newParams[prop]));
            }
            if (urlParts.length === 0) {
                return url;
            }
            return url + '?' + urlParts.join('&');
        }
        Helpers.setQueryString = setQueryString;
        function setButtonsetValue(id, value) {
            $('#' + id + ' [value="' + value + '"]').trigger('click');
        }
        Helpers.setButtonsetValue = setButtonsetValue;
    })(Helpers = MACRAIL.Helpers || (MACRAIL.Helpers = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    class Modal {
        constructor(opts) {
            this.defaultButtonDesc = {
                'class': 'btn-default',
            };
            this.alertVisible = false;
            this.opts = $.extend({
                'title': '',
                'body': '',
                'dialogClass': '',
                'headerClass': 'modal-header-primary',
                'showClose': true,
                'destroyOnClose': false,
                'fixedEnds': true,
                'container': $('#content-container'),
                'attachContainer': true,
                'buttons': Modal.defaultButtonGroups.okay,
                'bootstrapOptions': {
                    'keyboard': true,
                    'backdrop': true,
                },
            }, opts || {});
            this.modalDiv = $('<div>');
            if (this.opts.id) {
                if (document.getElementById(this.opts.id) !== null) {
                    throw new Error('The given id already exists.');
                }
                this.modalDiv.attr('id', this.opts.id);
            }
            else {
                this.modalDiv.uniqueId();
                this.opts.id = this.modalDiv.attr('id');
            }
            this.dialogDiv = null;
            this.contentDiv = null;
            this.headerDiv = null;
            this.alertDiv = null;
            this.alertCloseButton = null;
            this.bodyDiv = null;
            this.footerDiv = null;
            this._createModal();
        }
        setOption(name, value) {
            this.opts[name] = value;
            switch (name) {
                case 'title':
                    this.titleDiv.text(this.opts.title);
                    break;
            }
        }
        setButtons(buttons) {
            this.footerDiv.text('');
            let buttonCount = 0;
            for (let button of buttons) {
                buttonCount++;
                let buttonId = this.opts.id + '-button-' + button.name;
                let extraAttrs = '';
                button = $.extend({}, this.defaultButtonDesc, button);
                if (button.role === 'dismiss') {
                    extraAttrs += ' data-dismiss="modal"';
                }
                if (button.disabled) {
                    extraAttrs += ' disabled';
                }
                if (button.hidden) {
                    extraAttrs += ' style="display:none"';
                }
                this.footerDiv.append(`<button type="button" class="btn ${button.class}" id="${buttonId}" ${extraAttrs}>` +
                    `${button.text}` +
                    `</button>`);
            }
            this.footerDiv.css('display', buttonCount > 0 ? '' : 'none');
        }
        setButtonEnabled(name, enabled) {
            let buttonId = '#' + this.opts.id + '-button-' + name;
            $(buttonId).prop('disabled', !enabled);
        }
        show() {
            if (this.dialogDiv === null) {
                this._createModal();
            }
            this.clearAlert();
            this.modalDiv.modal(this.opts.bootstrapOptions).modal('show');
            this.resizeBody();
            if (typeof this.opts.onShow === 'function') {
                this.opts.onShow();
            }
        }
        hide() {
            this.modalDiv.modal('hide');
        }
        showLoader() {
            this.bodyDiv.html(`<div style="font-size: 30pt; padding: 40px; text-align: center;">` +
                `<i class="fa fa-spinner fa-pulse"></i>` +
                `</div>`);
        }
        loadBody(url, data) {
            $.post(url, data || {})
                .done($.proxy(this._onBodyLoadSuccess, this))
                .fail($.proxy(this._onBodyLoadError, this));
        }
        setAlert(className, html) {
            this.alertDiv.prop('class', 'modal-alert alert alert-' + className);
            let alertColour = this.alertDiv.css('borderLeftColor');
            this.alertDiv.css({ 'borderBottomColor': alertColour });
            this.alertCloseButton.css({ 'color': alertColour });
            this.alertDiv.find('span').html(html);
            this.alertDiv.show();
            this.alertVisible = true;
            this.resizeBody();
        }
        clearAlert() {
            this.alertVisible = false;
            this.alertDiv.hide();
            this.resizeBody();
        }
        _createModal() {
            let self = this;
            if (this.dialogDiv !== null) {
                return;
            }
            this.modalDiv.attr({
                'aria-hidden': true,
                'aria-labelledby': this.opts.id,
                'role': 'dialog',
                'tabindex': '-1',
            }).addClass('modal fade');
            this.dialogDiv = $('<div>').addClass('modal-dialog ' + this.opts.dialogClass);
            this.contentDiv = $('<div>').addClass('modal-content');
            this.headerDiv = $('<div>').addClass('modal-header ' + this.opts.headerClass);
            this.alertDiv = $('<div><span></span></div>').addClass('modal-alert alert').css('display', 'none');
            this.bodyDiv = $('<div>').addClass('modal-body');
            this.titleDiv = $('<div>').addClass('modal-title').text(this.opts.title);
            this.footerDiv = $('<div>').addClass('modal-footer').css('display', 'none');
            if (this.opts.showClose) {
                this.closeButton = $('<button>').attr({
                    'type': 'button',
                    'data-dismiss': 'modal',
                    'aria-hidden': true,
                }).addClass('close').html('<i class="fa fa-times"></i>');
                this.headerDiv.append(this.closeButton);
            }
            if (typeof this.opts.body === 'string') {
                if (this.opts.body.substr(0, 1) === '<') {
                    this.opts.body = $(this.opts.body);
                }
            }
            if (this.opts.body instanceof jQuery) {
                this.opts.body.css({ 'display': '' });
            }
            this.bodyDiv.append(this.opts.body);
            if (this.opts.buttons !== undefined) {
                this.setButtons(this.opts.buttons);
            }
            this.footerDiv.on('click', 'button', function (e) {
                let name = e.currentTarget.id;
                name = name.substr(name.lastIndexOf('-') + 1);
                self._onButtonClicked(name, e);
            });
            this.alertCloseButton = $('<button class="close"><i class="fa fa-times"></i></button>').attr({
                'type': 'button',
                'data-dismiss': 'alert',
                'aria-hidden': true,
            }).on('click', function () {
                self.clearAlert();
            });
            this.alertDiv.prepend(this.alertCloseButton);
            this.headerDiv.append(this.titleDiv);
            this.contentDiv.append(this.headerDiv);
            this.contentDiv.append(this.alertDiv);
            this.contentDiv.append(this.bodyDiv);
            this.contentDiv.append(this.footerDiv);
            this.dialogDiv.append(this.contentDiv);
            this.modalDiv.append(this.dialogDiv);
            if (this.opts.attachContainer) {
                this.opts.container.append(this.modalDiv);
            }
            if (this.opts.fixedEnds) {
                $(window).on('resize', $.proxy(this.resizeBody, this));
                this.modalDiv.on('shown.bs.modal', $.proxy(this.resizeBody, this));
            }
            this.modalDiv.on('hidden.bs.modal', (e) => {
                if (this.opts.destroyOnClose) {
                    this.modalDiv.remove();
                }
                if (typeof this.opts.onHide === 'function') {
                    this.opts.onHide();
                }
            });
        }
        resizeBody() {
            if (!this.opts.fixedEnds) {
                return;
            }
            let maxHeight = Math.floor($(window).height() -
                this.headerDiv.outerHeight() -
                (this.alertVisible ? this.alertDiv.outerHeight() : 0) -
                this.footerDiv.outerHeight() -
                parseInt(this.dialogDiv.css('margin-top'), 10) * 2);
            this.bodyDiv.css({
                'maxHeight': `${maxHeight}px`,
                'overflowY': 'scroll',
            });
        }
        _onBodyLoadSuccess(data, status, request) {
            switch (typeof data) {
                case 'string':
                    this.bodyDiv.html(data);
                    break;
                case 'object':
                    this.bodyDiv.html(data.html);
                    break;
                default:
                    this._onBodyLoadError(request, 'error');
                    break;
            }
            if (typeof (this._formOnBodyLoad) === 'function') {
                this._formOnBodyLoad();
            }
            if (typeof this.opts.onBodyLoad === 'function') {
                this.opts.onBodyLoad();
            }
        }
        _onBodyLoadError(request, status) {
            let errorMsg = 'An unexpected error occured while loading. Please refresh the page and try again.';
            if (request.responseJSON && request.responseJSON.message) {
                errorMsg += '<br /><br />' + request.responseJSON.message;
            }
            this.setAlert('danger', errorMsg);
            this.bodyDiv.html('');
        }
        _onButtonClicked(button, e) {
            if (this.opts.onButtonClick) {
                this.opts.onButtonClick(button);
            }
        }
        _formOnBodyLoad() {
        }
    }
    Modal.defaultButtons = {
        'close': {
            'name': 'close',
            'text': 'Close',
            'role': 'dismiss',
        },
        'okay': {
            'name': 'okay',
            'text': 'OK',
        },
    };
    Modal.defaultButtonGroups = {
        'close': [
            Modal.defaultButtons.close,
        ],
        'okay': [
            Modal.defaultButtons.okay,
        ],
    };
    MACRAIL.Modal = Modal;
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    class ModalForm extends MACRAIL.Modal {
        constructor(opts) {
            opts = $.extend({
                'loadUrl': '',
                'loadData': {},
                'submitData': {},
                'buttons': [{
                        'name': 'save',
                        'text': 'Save',
                        'class': 'btn-success',
                    }, {
                        'name': 'cancel',
                        'text': 'Cancel',
                        'role': 'dismiss',
                    }],
                'saveSuccessAction': 'closeonly',
            }, opts || {});
            super(opts);
        }
        show() {
            this.setButtons(this.opts.buttons);
            super.show();
            this.showLoader();
            this.clearAlert();
            if (this.opts.loadUrl === '') {
                throw 'Modal::show - loadUrl is blank';
            }
            this.loadBody(this.opts.loadUrl, this.opts.loadData);
        }
        _formOnBodyLoad() {
            let self = this;
            let form = this.bodyDiv.find('form');
            form.on('submit', function (e) {
                e.preventDefault();
            });
            form.on('keyup', 'input[type="text"]:not(.ui-autocomplete-input)', function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    self._onButtonClicked('save');
                }
            });
        }
        _onButtonClicked(button) {
            switch (button) {
                case 'save':
                    this.setAlert('info', 'Saving...');
                    this.setButtonEnabled('save', false);
                    let form = this.bodyDiv.find('form');
                    let formData = form.serializeArray();
                    if (!jQuery.isEmptyObject(this.opts.submitData)) {
                        $.each(this.opts.submitData, function (k, v) {
                            formData.push({
                                'name': k,
                                'value': v,
                            });
                        });
                    }
                    $(':input', form).each(function () {
                        $(this).parents('.form-group').removeClass('has-error');
                    });
                    $.post(this.opts.submitUrl, formData).always($.proxy(this._onSaveResponse, this));
                    break;
                case 'close':
                    this.hide();
                    break;
            }
        }
        _onSaveResponse(data, status) {
            this.setButtonEnabled('save', true);
            if (status !== 'success' || typeof data !== 'object') {
                this.setAlert('danger', 'An unexpected error occured while saving. Please refresh the page and try again.');
                return;
            }
            if (data.status !== 'success') {
                this.setAlert(data.alertClass || 'danger', data.message);
                if (data.fields !== undefined) {
                    let form = this.bodyDiv.find('form');
                    $.each(data.fields, function (k, v) {
                        $('[name=' + v + ']', form).parents('.form-group').addClass('has-error');
                    });
                }
                if (typeof this.opts.onSaveFailure === 'function') {
                    this.opts.onSaveFailure(data, status);
                }
                return;
            }
            this.setAlert(data.alertClass || 'success', data.message);
            switch (this.opts.saveSuccessAction) {
                case 'closeonly':
                    this.setButtons(MACRAIL.Modal.defaultButtonGroups.close);
                    break;
            }
            if (typeof this.opts.onSaveSuccess === 'function') {
                this.opts.onSaveSuccess(data, status);
            }
        }
    }
    MACRAIL.ModalForm = ModalForm;
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    class StickyHeader {
        constructor(element, opts) {
            this.oldTop = 0;
            this.element = element;
            this.opts = opts;
            $('#content-container').prepend(element);
            element.css({
                'position': 'fixed',
                'top': $('#header').height() + 'px',
                'width': '100%',
                'zIndex': 9,
            });
            this.recalculate();
        }
        recalculate() {
            let newTop = Math.ceil($('#header').height() + this.element.outerHeight());
            if (newTop !== this.oldTop) {
                $('#content').css('padding-top', newTop + 'px');
                this.oldTop = newTop;
                if (this.opts.callback) {
                    this.opts.callback(newTop);
                }
            }
        }
    }
    MACRAIL.StickyHeader = StickyHeader;
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class BaseField {
                constructor(element, opts = {}) {
                    this.enabled = true;
                    this.defaultValue = undefined;
                    this.dirty = false;
                    this.validators = [];
                    this.disabledValidators = [];
                    this.validationMessages = {};
                    this.validationSlugs = [];
                    this.element = $(element);
                    this.statusElement = this.element.closest('.tabbedform-form-alert-container');
                    if (this.element.length === 0) {
                        throw 'Unable to find element for field: ' + element;
                    }
                    this.name = this.element.prop('id');
                    this.element.addClass('clean');
                    this.opts = opts;
                    if (this.opts.hasOwnProperty('defaultValue')) {
                        this.defaultValue = this.opts.defaultValue;
                    }
                    else {
                        this.defaultValue = this.getValue();
                    }
                }
                getElement() {
                    return this.element;
                }
                setName(newName) {
                    this.name = newName;
                }
                getName() {
                    return this.name;
                }
                addValidator(validator) {
                    this.validators.push(validator);
                }
                getValidators() {
                    return this.validators;
                }
                replaceValidator(name, opts) {
                    let newValidator = new MACRAIL.Validation[`${name}Validator`](opts);
                    for (let validator of this.validators) {
                        if (validator instanceof MACRAIL.Validation[`${name}Validator`]) {
                            let elementPos = this.validators.indexOf(validator);
                            this.validators.splice(elementPos, 1);
                            this.addValidator(newValidator);
                        }
                    }
                }
                disableValidator(name) {
                    for (let validator of this.validators) {
                        if (validator instanceof MACRAIL.Validation[`${name}Validator`]) {
                            this.disabledValidators.push(validator);
                            let elementPos = this.validators.indexOf(validator);
                            this.validators.splice(elementPos, 1);
                        }
                    }
                }
                enableValidator(name) {
                    for (let validator of this.disabledValidators) {
                        if (validator instanceof MACRAIL.Validation[`${name}Validator`]) {
                            this.addValidator(validator);
                            let elementPos = this.disabledValidators.indexOf(validator);
                            this.disabledValidators.splice(elementPos, 1);
                        }
                    }
                }
                validate(force) {
                    let existingSlugs = this.validationSlugs.slice();
                    let newSlugs = [];
                    let hasWarnings = false;
                    let hasErrors = false;
                    if (force) {
                        this.setDirty(true);
                    }
                    if (!this.isDirty()) {
                        return;
                    }
                    for (let validator of this.validators) {
                        let messages = validator.validate(this.getValue());
                        if (messages.length > 0) {
                            for (let message of messages) {
                                if (message.status === 'error') {
                                    hasErrors = true;
                                }
                                else {
                                    hasWarnings = true;
                                }
                                if (!message.message || message.message === '') {
                                    this.clearMessage(message.slug);
                                }
                                else {
                                    this.setMessage(message.slug, message.status, message.message);
                                }
                                newSlugs.push(message.slug);
                            }
                        }
                    }
                    let removedSlugs = existingSlugs.filter((x) => newSlugs.indexOf(x) === -1);
                    for (let slug of removedSlugs) {
                        this.clearMessage(slug);
                    }
                    this.validationSlugs = newSlugs;
                    let isAlert = this.statusElement.hasClass('alert');
                    this.statusElement.removeClass('has-error has-warning');
                    if (hasErrors) {
                        this.statusElement.addClass('has-error');
                        if (isAlert) {
                            this.statusElement.setAlertClass('danger');
                        }
                    }
                    else if (hasWarnings) {
                        this.statusElement.addClass('has-warning');
                        if (isAlert) {
                            this.statusElement.setAlertClass('warning');
                        }
                    }
                    else {
                        if (isAlert) {
                            this.statusElement.setAlertClass('default');
                        }
                    }
                }
                getValidationMessages() {
                    return this.validationMessages;
                }
                reset() {
                    this.setValue(this.defaultValue);
                    this.setDirty(false);
                    let messagesElement = this.getMessagesElement();
                    if (messagesElement) {
                        messagesElement.text('');
                    }
                    this.statusElement.removeClass('has-warning has-error');
                }
                isEnabled() {
                    return this.enabled;
                }
                setEnabled(enabled) {
                    this.enabled = enabled;
                    let noteElement = this.getNoteElement();
                    if (enabled) {
                        this.element
                            .prop('disabled', false)
                            .removeClass('disabled');
                        if (noteElement) {
                            noteElement.removeClass('disabled');
                        }
                    }
                    else {
                        this.element
                            .prop('disabled', true)
                            .addClass('disabled');
                        if (noteElement) {
                            noteElement.addClass('disabled');
                        }
                    }
                }
                setDirty(newDirty) {
                    this.dirty = newDirty;
                    if (newDirty) {
                        this.element.removeClass('clean');
                    }
                    else {
                        this.element.addClass('clean');
                    }
                }
                isDirty() {
                    return this.dirty;
                }
                getValue() {
                    return this.value;
                }
                setValue(newValue) {
                    let currentValue = this.element.val();
                    if (newValue == currentValue) {
                        return;
                    }
                    this.element.val(newValue);
                    this.value = newValue;
                    this.setDirty(true);
                    this.element.trigger('change');
                }
                setNote(newNote) {
                    let noteDiv = this.getNoteElement();
                    if (noteDiv) {
                        noteDiv.text(newNote);
                    }
                }
                setMessage(slug, status, message) {
                    this.validationMessages[slug] = {
                        'message': message,
                        'slug': slug,
                        'status': status,
                    };
                    let messages = this.getMessagesElement();
                    if (!messages) {
                        return;
                    }
                    let messagesElement = messages.find(`div[data-slug="${slug}"]`);
                    let state = status;
                    if (state === 'error') {
                        state = 'danger';
                    }
                    if (messagesElement.length) {
                        messagesElement
                            .removeClass('highlight-warning highlight-danger')
                            .addClass(`highlight-${state}`)
                            .html(message);
                    }
                    else {
                        messages.append(`<div data-slug="${slug}" class="highlight-${state}">${message}</div>`);
                    }
                }
                clearMessage(slug) {
                    delete this.validationMessages[slug];
                    let messagesElement = this.getMessagesElement();
                    if (!messagesElement) {
                        return;
                    }
                    let message = messagesElement.find(`[data-slug="${slug}"]`);
                    message.remove();
                }
                getMessages() {
                    return this.validationMessages;
                }
                getLabel() {
                    let el = this.getLabelElement();
                    if (el && el.length) {
                        return el.text();
                    }
                    return this.name;
                }
                getLabelElement() {
                    return this.getRelatedElement('label[for="{NAME}"]');
                }
                getNoteElement() {
                    return this.getRelatedElement('div[data-note-for="{NAME}"]');
                }
                getMessagesElement() {
                    return this.getRelatedElement('div[data-messages-for="{NAME}"]');
                }
                getRelatedElement(css) {
                    if (this.name === '') {
                        return undefined;
                    }
                    let element = $(css.replace('{NAME}', this.name));
                    if (element.length !== 1) {
                        return undefined;
                    }
                    return element;
                }
            }
            Fields.BaseField = BaseField;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class Buttonset extends Fields.BaseField {
                constructor(element, opts = {}) {
                    super(element, opts);
                    let self = this;
                }
                setEnabled(enabled) {
                    super.setEnabled(enabled);
                    if (enabled) {
                        this.element.find('label').removeClass('disabled');
                        this.element.find('input').prop('disabled', false);
                    }
                    else {
                        this.element.find('label').addClass('disabled');
                        this.element.find('input').prop('disabled', true);
                    }
                }
                setValueEnabled(value, enabled) {
                    let $label = this.element.find('input[value="' + value + '"]').parent();
                    if (enabled) {
                        $label
                            .prop('disabled', false)
                            .removeClass('disabled');
                    }
                    else {
                        $label
                            .prop('disabled', true)
                            .addClass('disabled');
                    }
                }
                getValue() {
                    return this.element.find('input:checked').val();
                }
                setValue(newValue) {
                    let wasDisabled = false;
                    if (!this.isEnabled()) {
                        wasDisabled = true;
                        this.setEnabled(true);
                    }
                    if (newValue === undefined) {
                        this.element
                            .find('input:checked')
                            .prop('checked', false)
                            .parent()
                            .removeClass('active');
                    }
                    else {
                        this.element.find('[value="' + newValue + '"]').trigger('click');
                    }
                    if (wasDisabled) {
                        this.setEnabled(false);
                    }
                }
            }
            Fields.Buttonset = Buttonset;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class Text extends Fields.BaseField {
                constructor(element, opts = {}) {
                    super(element, opts);
                    let self = this;
                    if (this.opts.transform === 'uppercase') {
                        this.element.css({ 'textTransform': 'uppercase' });
                    }
                }
                getValue() {
                    let value = this.element.val();
                    if (this.opts.transform === 'uppercase') {
                        value = value.toLocaleUpperCase();
                    }
                    return value;
                }
            }
            Fields.Text = Text;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class Combo extends Fields.Text {
                constructor(element, opts = {}) {
                    super(element, opts);
                    if (!this.opts.source) {
                        this.opts.source = [];
                    }
                    this.element.autocomplete({
                        'delay': 0,
                        'source': this.opts.source,
                        'minLength': 0,
                        'select': (event, ui) => {
                            this.element.autocomplete('close');
                        },
                    });
                    this.element.on('autocompletechange', (event, ui) => {
                        this.element.trigger('change');
                    });
                    this.element.on('focus', () => {
                        this.element.autocomplete('search', '');
                    });
                }
                setSource(source) {
                    this.element.autocomplete('option', 'source', source);
                }
            }
            Fields.Combo = Combo;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class Duration extends Fields.BaseField {
                constructor(element, opts = {}) {
                    super(element, opts);
                    this.hourInput = this.element.find('#' + this.element.prop('id') + '_hour');
                    this.minuteInput = this.element.find('#' + this.element.prop('id') + '_minute');
                    this.element.on('change', () => {
                        this.onChange();
                    });
                }
                setEnabled(enabled) {
                    super.setEnabled(enabled);
                    if (enabled) {
                        this.hourInput
                            .prop('disabled', false)
                            .removeClass('disabled');
                        this.minuteInput
                            .prop('disabled', false)
                            .removeClass('disabled');
                    }
                    else {
                        this.hourInput
                            .prop('disabled', true)
                            .addClass('disabled');
                        this.minuteInput
                            .prop('disabled', true)
                            .addClass('disabled');
                    }
                }
                setValue(newValue) {
                    let changed = false;
                    if (this.value === newValue) {
                        return;
                    }
                    if (newValue === undefined) {
                        this.value = undefined;
                        changed = true;
                    }
                    if (typeof newValue === 'number' && !isNaN(newValue)) {
                        this.value = newValue;
                        changed = true;
                    }
                    if (changed) {
                        this.setDirty(true);
                        this.formatDisplay();
                    }
                }
                onChange() {
                    let hourVal = this.hourInput.val().trim();
                    let minuteVal = this.minuteInput.val().trim();
                    if (hourVal === '' && minuteVal === '') {
                        this.setValue(undefined);
                        return;
                    }
                    if (hourVal === '') {
                        hourVal = '0';
                    }
                    if (minuteVal === '') {
                        minuteVal = '0';
                    }
                    if (!hourVal.match(/^\d+$/) || !minuteVal.match(/^\d+$/)) {
                        this.value = undefined;
                        return;
                    }
                    let hour = parseInt(hourVal, 10);
                    let minute = parseInt(minuteVal, 10);
                    if (isNaN(hour) || isNaN(minute) || hour < 0 || minute < 0 || minute > 59) {
                        this.setValue(undefined);
                        this.value = undefined;
                        return;
                    }
                    this.setValue(hour * 3600000 + minute * 60000);
                }
                formatDisplay() {
                    if (this.value === undefined) {
                        this.hourInput.val('');
                        this.minuteInput.val('');
                        return;
                    }
                    this.hourInput.val(Math.floor(this.value / 3600000));
                    this.minuteInput.val(Math.floor((this.value % 3600000) / 60000));
                }
            }
            Fields.Duration = Duration;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class Select extends Fields.BaseField {
                constructor(element, opts = {}) {
                    super(element, opts);
                    this.element.on('change', (e) => {
                        let newValue = this.element.val();
                        this.value = newValue;
                    });
                }
                reset() {
                    super.reset();
                    this.setValue(this.element.find('option:first-child').val());
                    this.setDirty(false);
                }
                getValue() {
                    let value = this.element.val();
                    if (value === '-1') {
                        value = undefined;
                    }
                    return value;
                }
            }
            Fields.Select = Select;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class SimpleDate extends Fields.BaseField {
                constructor(element, opts = {}) {
                    super(element, opts);
                    this.inputForUser = this.element.find('input[type="text"]');
                    let datePickerOptions = {
                        'dateFormat': 'D, d M yy',
                    };
                    datePickerOptions = $.extend({}, MACRAIL.defaultDatePickerOptions, datePickerOptions);
                    this.inputForUser.datepicker(datePickerOptions);
                }
                setEnabled(enabled) {
                    super.setEnabled(enabled);
                    if (enabled) {
                        this.inputForUser
                            .prop('disabled', false)
                            .removeClass('disabled');
                    }
                    else {
                        this.inputForUser
                            .prop('disabled', true)
                            .addClass('disabled');
                    }
                }
                setValue(newValue) {
                    if (newValue && newValue.getFullYear) {
                        this.inputForUser.datepicker('setDate', newValue);
                    }
                }
                getValue() {
                    if (!this.inputForUser) {
                        return undefined;
                    }
                    return this.inputForUser.datepicker('getDate');
                }
            }
            Fields.SimpleDate = SimpleDate;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class SimpleTime extends Fields.BaseField {
                constructor(element, opts = {}) {
                    opts.allowFuture = opts.allowFuture || 0;
                    if (typeof opts.allowFuture === 'string') {
                        switch (opts.allowFuture.substr(opts.allowFuture.length - 1)) {
                            case 'm':
                                opts.allowFuture = parseInt(opts.allowFuture, 10) * 60000;
                                break;
                            case 'h':
                                opts.allowFuture = parseInt(opts.allowFuture, 10) * 3600000;
                                break;
                            default:
                                opts.allowFuture = parseInt(opts.allowFuture, 10);
                                break;
                        }
                    }
                    super(element, opts);
                    this.inputForUser = this.element.find('input[type="text"]');
                    this.defaultAddonHtml = this.element.find('.input-group-addon').html();
                    this.element.on('change', () => {
                        this.recalculate();
                    });
                    setInterval(() => {
                        if (this.inputForUser.is(':focus')) {
                            return;
                        }
                        this.recalculate();
                    }, 60000);
                }
                setRelativeTo(relativeTo) {
                    this.relativeTo = relativeTo;
                    $(this.relativeTo.getElement()).on('change', () => {
                        this.recalculate();
                        this.element.trigger('change');
                    });
                }
                setEnabled(enabled) {
                    super.setEnabled(enabled);
                    if (enabled) {
                        this.inputForUser
                            .prop('disabled', false)
                            .removeClass('disabled');
                    }
                    else {
                        this.inputForUser
                            .prop('disabled', true)
                            .addClass('disabled');
                    }
                }
                setValue(newValue) {
                    if (newValue && newValue.getFullYear) {
                        newValue = (newValue.getHours() < 10 ? '0' : '') + newValue.getHours() + ':' +
                            (newValue.getMinutes() < 10 ? '0' : '') + newValue.getMinutes();
                    }
                    this.inputForUser.val(newValue);
                    this.setDirty(true);
                    this.recalculate();
                }
                recalculate() {
                    let val = this.inputForUser.val();
                    let $addon = this.element.find('.input-group-addon');
                    if (val === '') {
                        $addon.html(this.defaultAddonHtml);
                        this.value = undefined;
                        return false;
                    }
                    let splitTime = val.match(/^(\d\d)[^\d]?(\d\d)$/);
                    if (!splitTime || splitTime.length !== 3 || splitTime[1] > 23 || splitTime[2] > 59) {
                        $addon.html('<i class="fa fa-ban" style="color: #994444;"></i>');
                        this.value = undefined;
                        return false;
                    }
                    if (splitTime.length === 3) {
                        val = ('0' + splitTime[1]).substr(-2, 2) + ':' + splitTime[2];
                        this.inputForUser.val(val);
                    }
                    let dateCalc = undefined;
                    let now = (new Date()).getTime();
                    if (this.relativeTo instanceof Fields.SimpleDate) {
                        dateCalc = this.relativeTo.getValue();
                        dateCalc.setHours(parseInt(splitTime[1], 10), parseInt(splitTime[2], 10), 0, 0);
                    }
                    else if (this.relativeTo instanceof SimpleTime) {
                        let otherDate = this.relativeTo.getValue();
                        if (otherDate) {
                            dateCalc = new Date(otherDate.getTime());
                            dateCalc.setHours(parseInt(splitTime[1], 10), parseInt(splitTime[2], 10), 0, 0);
                            if (dateCalc.getTime() < otherDate.getTime()) {
                                dateCalc.setDate(dateCalc.getDate() + 1);
                            }
                        }
                    }
                    if (!dateCalc) {
                        dateCalc = new Date();
                        dateCalc.setHours(parseInt(splitTime[1], 10), parseInt(splitTime[2], 10), 0, 0);
                        let diff2 = dateCalc.getTime() - now;
                        if (diff2 > this.opts.allowFuture) {
                            dateCalc.setDate(dateCalc.getDate() - 1);
                        }
                        else if (diff2 < this.opts.allowFuture - 24 * 3600000) {
                            dateCalc.setDate(dateCalc.getDate() + 1);
                        }
                    }
                    let triggerEvent = false;
                    if (this.value && this.value.getTime() !== dateCalc.getTime()) {
                        triggerEvent = true;
                    }
                    this.value = dateCalc;
                    let html = this.defaultAddonHtml;
                    let diffInDays = (now - dateCalc.getTime()) / 86400000;
                    if (diffInDays < 60) {
                        html = '<small>' + MACRAIL.Helpers.formatRelativeTime(dateCalc) + '</small>';
                    }
                    $addon.html(html);
                    if (triggerEvent) {
                        this.element.trigger('fieldchanged');
                    }
                    return true;
                }
            }
            Fields.SimpleTime = SimpleTime;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        class Form extends MACRAIL.EventEmitter {
            constructor(opts) {
                super();
                this.help = {};
                this.fields = {};
                this.validate = (force = false) => {
                    if (this.validateTimer !== undefined) {
                        clearTimeout(this.validateTimer);
                        this.validateTimer = undefined;
                    }
                    this.validateTimer = window.setTimeout(() => { this.validateReal(force); }, 10);
                };
                this.validateReal = (force = false) => {
                    this.trigger('beforevalidate');
                    this.validateTimer = undefined;
                    for (let fieldName in this.fields) {
                        if (this.fields.hasOwnProperty(fieldName)) {
                            this.fields[fieldName].validate(force);
                        }
                    }
                    if (this.opts.tabbedform) {
                        this.opts.tabbedform.updateTabStatuses();
                    }
                    this.trigger('validated');
                };
                this.element = opts.form;
                this.opts = opts;
                let self = this;
                this.element.on('fieldchanged confirmalertchange', (e) => {
                    this.validate();
                });
                this.element.on('mouseover', function (e) {
                    let el = e.target;
                    let helpKey = $(el).data('helpkey');
                    if (helpKey === undefined) {
                        helpKey = $(el).parents('[data-helpkey]').data('helpkey');
                        if (helpKey === undefined) {
                            return;
                        }
                    }
                    if (self.help[helpKey]) {
                        let helpContent = self.help[helpKey];
                        if (typeof helpContent === 'function') {
                            helpContent = helpContent();
                        }
                        let label = $('label[for="' + helpKey + '"]');
                        if (self.opts.helpToast) {
                            self.opts.helpToast.find('.toasthelp-title').html(label.length ? label.text() : helpKey);
                            self.opts.helpToast.find('.toasthelp-content').html(helpContent);
                        }
                    }
                    else {
                        if (self.opts.helpToast) {
                            self.opts.helpToast.find('.toasthelp-title').html('Help');
                            self.opts.helpToast.find('.toasthelp-content').html('Relevant help will show here when available.');
                        }
                    }
                }).trigger('mouseover');
            }
            autoConfigure() {
                this.element.find('[data-form-type]').each((i, el) => {
                    let $el = $(el);
                    this.addField($el.attr('name') || $el.data('name'), new Forms.Fields[$el.data('form-type')]($el), {});
                });
            }
            addField(name, field, validators) {
                this.fields[name] = field;
                for (let validator in validators) {
                    if (validators.hasOwnProperty(validator)) {
                        this.addValidator(name, validator, validators[validator]);
                    }
                }
                let self = this;
                let $input = field.getElement();
                $input.on('change', function (e) {
                    let id = this.id || $(e.target).parents('[id]').attr('id');
                    field.setDirty(true);
                    self.validate();
                });
                return field;
            }
            getField(name) {
                return this.fields[name];
            }
            getFields() {
                return this.fields;
            }
            removeField(name) {
                delete this.fields[name];
            }
            addValidator(field, validatorName, opts) {
                let validator = new MACRAIL.Validation[`${validatorName}Validator`](opts);
                if (this.fields[field] === undefined) {
                    throw `Field '${field}' not found in Form.`;
                }
                this.fields[field].addValidator(validator);
            }
            enableValidator(field, validatorName) {
                if (this.fields[field] === undefined) {
                    throw `Field '${field}' not found in Form.`;
                }
                this.fields[field].enableValidator(validatorName);
            }
            disableValidator(field, validatorName) {
                if (this.fields[field] === undefined) {
                    throw `Field '${field}' not found in Form.`;
                }
                this.fields[field].disableValidator(validatorName);
            }
            replaceValidator(field, validatorName, opts) {
                if (this.fields[field] === undefined) {
                    throw `Field '${field}' not found in Form.`;
                }
                this.fields[field].replaceValidator(validatorName, opts);
            }
            setHelp(help) {
                this.help = help;
                if (this.opts.helpToast) {
                    this.opts.helpToast.find('.toasthelp-content').html(this.help.sentinelcheck);
                }
            }
            getValidationMessages(fieldName) {
                let field = this.fields[fieldName];
                if (field === undefined) {
                    return [];
                }
                let value = field.getValue();
                let hasWarnings = false;
                let hasErrors = false;
                let allMessages = [];
                for (let validator of field.getValidators()) {
                    let messages = validator.validate(value);
                    if (messages.length > 0) {
                        for (let message of messages) {
                            allMessages.push(message);
                            if (message.status === 'error') {
                                hasErrors = true;
                            }
                            else {
                                hasWarnings = true;
                            }
                        }
                    }
                }
                return allMessages;
            }
            setStatus(status, message) {
                this.element.find('.form-status').prop('class', 'form-status highlight-' + status).text(message);
            }
            clearStatus() {
                this.element.find('.form-status').text('');
            }
            hasWarnings(opts = {}) {
                return this.hasFieldsWithClass('warning', opts);
            }
            hasErrors(opts = {}) {
                return this.hasFieldsWithClass('error', opts);
            }
            setNote(field, noteText) {
                this.fields[field].setNote(noteText);
            }
            setMessage(field, slug, state, message) {
                this.fields[field].setMessage(slug, state, message);
            }
            clearMessage(field, slug) {
                this.fields[field].clearMessage(slug);
            }
            getValues() {
                let values = {};
                for (let fieldName in this.fields) {
                    if (this.fields.hasOwnProperty(fieldName)) {
                        values[fieldName] = this.fields[fieldName].getValue();
                    }
                }
                return values;
            }
            getFormData() {
                let formData = new FormData();
                for (let fieldName in this.fields) {
                    if (this.fields.hasOwnProperty(fieldName)) {
                        formData.append(fieldName, this.fields[fieldName].getValue());
                    }
                }
                return formData;
            }
            reset() {
                for (let fieldName in this.fields) {
                    if (this.fields.hasOwnProperty(fieldName)) {
                        this.fields[fieldName].reset();
                    }
                }
                this.clearStatus();
            }
            hasFieldsWithClass(className, opts = {}) {
                let selector = '.has-' + className;
                if (this.opts.tabbedform) {
                    let ignoreSel = '';
                    if (opts.ignoreTabs) {
                        for (let tab of opts.ignoreTabs) {
                            ignoreSel += ':not([data-id="' + tab + '"])';
                        }
                    }
                    selector = '.tabbedform-tab:not(.tabbedform-tab-hide)' + ignoreSel + ' ' + selector;
                }
                return this.element.find(selector).length > 0;
            }
        }
        Forms.Form = Form;
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        class TabbedForm {
            constructor(opts) {
                let self = this;
                this.opts = opts;
                if (this.opts.minSidebarPosition) {
                    this.opts.minSidebarPosition = Math.floor(this.opts.minSidebarPosition);
                }
                else {
                    this.opts.minSidebarPosition = 0;
                }
                this.container = opts.container;
                this.container.find('.tabbedform-buttons').on('click', '.tabbedform-button', function () {
                    self.setTab($(this).data('id'));
                });
                $(document).on('scroll', function () {
                    self.repositionSidebar();
                });
            }
            setOption(name, value) {
                this.opts[name] = value;
            }
            setTab(id) {
                this.container.find('.tabbedform-button').removeClass('tabbedform-button-active');
                if (this.opts.singleTab) {
                    this.container.find('.tabbedform-tab').hide();
                    this.getTab(id).show();
                }
                else {
                    $('html,body').animate({
                        'scrollTop': ((this.getTab(id).offset().top) - this.opts.minSidebarPosition),
                    }, 'slow');
                }
            }
            updateTabStatuses() {
                let tabs = this.container.find('.tabbedform-tab');
                tabs.each((i, tab) => {
                    let $tab = $(tab);
                    let tabId = $tab.data('id');
                    $tab.removeClass('has-error has-warning');
                    let fieldCount = $tab.find('.tabbedform-form-alert-container:visible').length;
                    let warnings = $tab.find('.has-warning').length;
                    let dangers = $tab.find('.has-error').length;
                    let clean = $tab.find('.clean:visible').length;
                    this.setTabWidget(tabId, 'warning', warnings);
                    this.setTabWidget(tabId, 'danger', dangers);
                    if (dangers > 0) {
                        this.setTabStatus(tabId, 'danger');
                    }
                    else if (warnings > 0) {
                        this.setTabStatus(tabId, 'warning');
                    }
                    else {
                        if (clean || fieldCount === 0) {
                            this.setTabStatus(tabId, 'default');
                        }
                        else {
                            this.setTabStatus(tabId, 'success');
                        }
                    }
                });
            }
            setTabStatus(id, status) {
                this.getButton(id)
                    .removeClass('tabbedform-button-status-success tabbedform-button-status-warning tabbedform-button-status-danger')
                    .addClass(`tabbedform-button-status-${status}`);
                this.getTab(id)
                    .removeClass('box-default box-success box-warning box-danger')
                    .addClass(`box-${status}`);
            }
            setTabWidget(id, status, count) {
                let button = this.getButton(id);
                if (button.find('.tabbedform-button-widgets').length === 0) {
                    button.prepend(`
                <div class="tabbedform-button-widgets">
                    <div class="widget widget-xxxs widget-warning" style="display: none;">0</div>
                    <div class="widget widget-xxxs widget-danger" style="display: none;">0</div>
                </div>
            `);
                }
                let widget = button.find(`.widget-${status}`);
                widget.text(count);
                if (count > 0) {
                    widget.show();
                }
                else {
                    widget.hide();
                }
            }
            hideTab(id) {
                this.getTab(id).addClass('tabbedform-tab-hide');
                this.getButton(id).hide();
            }
            showTab(id) {
                this.getTab(id).removeClass('tabbedform-tab-hide');
                this.getButton(id).show();
            }
            repositionSidebar() {
                let minPos = this.opts.minSidebarPosition;
                let pos = Math.floor($('.tabbedform-tabs').offset().top - $(document).scrollTop());
                $('.tabbedform-sidebar').css('top', pos > minPos ? pos : minPos);
            }
            getButton(id) {
                return this.container.find(`.tabbedform-button[data-id="${id}"]`);
            }
            getTab(id) {
                return this.container.find(`.tabbedform-tab[data-id="${id}"]`);
            }
        }
        Forms.TabbedForm = TabbedForm;
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var UI;
    (function (UI) {
        class HelpTips {
            constructor(rootElement, file) {
                this.qTip = MACRAIL.Helpers.createQtip({
                    'target': $('<div />'),
                    'position': 'below',
                    'class': 'info',
                    'extraClasses': 'helptip',
                    'title': 'Help',
                    'content': 'PLACEHOLDER',
                });
                $.getJSON(file, (data, textStatus, jqXHR) => {
                    this.json = data;
                    for (let id in data) {
                        if (!data.hasOwnProperty(id)) {
                            continue;
                        }
                        let element = $(`label[for="${id}"]`);
                        if (element.length === 0) {
                            element = $(`#${id}`);
                        }
                        if (element.length === 0) {
                            continue;
                        }
                        let icon = $(`<i class="fa fa-question-circle-o helptip-icon highlight-info" data-slug="${id}"></i>`);
                        element
                            .prepend(' ')
                            .prepend(icon)
                            .css('position', 'relative');
                        icon.on('click', (e) => {
                            let iconEl = $(e.target);
                            let slug = iconEl.data('slug');
                            let help = data[slug];
                            let desc = help.desc.replace(/\n/g, '</p><p>');
                            let content = `<div>Description</div><p>${desc}</p>`;
                            if (help.say) {
                                content += `<div>Say</div><p>"${help.say}"</p>`;
                            }
                            if (help.example) {
                                content += `<div>Example</div><p>${help.example}</p>`;
                            }
                            let title = iconEl.parent().text();
                            this.qTip.set('content.title', title);
                            this.qTip.set('content.text', content);
                            this.qTip.set('position.target', icon);
                            this.qTip.set('show.target', icon);
                            this.qTip.show();
                            e.preventDefault();
                            e.stopPropagation();
                        });
                    }
                });
            }
        }
        UI.HelpTips = HelpTips;
    })(UI = MACRAIL.UI || (MACRAIL.UI = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var UI;
    (function (UI) {
        class Snackbar {
            static show(arg1, arg2) {
                if (typeof arg1 === 'string' && arg2 === undefined) {
                    this.messages.push({
                        'class': 'default',
                        'message': arg1,
                    });
                }
                else if (typeof arg2 === 'string') {
                    this.messages.push({
                        'class': arg1,
                        'message': arg2,
                    });
                }
                else {
                    this.messages.push(arg1);
                }
                if (!this.processing) {
                    this.showNextMessage();
                }
            }
            static test() {
                let states = ['default', 'primary', 'info', 'success', 'warning', 'danger'];
                MACRAIL.UI.Snackbar.show({
                    'class': states[Math.floor(Math.random() * 6)],
                    'message': new Date().toString(),
                });
            }
            static showNextMessage() {
                this.processing = true;
                this.createElement();
                if (this.messages.length === 0) {
                    return;
                }
                let message = this.messages.splice(0, 1)[0];
                this.element.prop('class', message.class);
                this.element.text(message.message);
                this.element.height();
                this.element.addClass('active');
                this.timer = window.setTimeout(this.closeMessage.bind(this), this.minDisplayTime);
            }
            static closeMessage() {
                this.element.removeClass('active');
                if (this.messages.length) {
                    this.timer = window.setTimeout(this.showNextMessage.bind(this), 1000);
                }
                else {
                    this.processing = false;
                }
            }
            static createElement() {
                if (this.element !== undefined) {
                    return;
                }
                this.element = $('<div id="snackbar">').appendTo(document.body);
            }
        }
        Snackbar.minDisplayTime = 4000;
        Snackbar.messages = [];
        Snackbar.processing = false;
        UI.Snackbar = Snackbar;
    })(UI = MACRAIL.UI || (MACRAIL.UI = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var UI;
    (function (UI) {
        class Screens {
            static show(screen, data = {}, opts = {}) {
                let time = (new Date()).getTime();
                let lastTime = Screens.lastShowTime;
                Screens.lastShowTime = time;
                if (lastTime > time - 1000) {
                    console.info('Blocked opening a second screen too quickly.');
                    return;
                }
                let url = Screens.urlForScreen('show', screen);
                let errorMessage = 'There was an error opening that screen.';
                $.post(url, data)
                    .done(function (response) {
                    if (typeof response !== 'object') {
                        MACRAIL.UI.Snackbar.show('danger', errorMessage);
                        return;
                    }
                    if (response.status && response.status === 'error') {
                        MACRAIL.UI.Snackbar.show('danger', response.message || errorMessage);
                        return;
                    }
                    if (!response.forceOpen && $('body').hasClass('modal-open')) {
                        console.info('Blocked opening a screen because a modal dialog is already open.');
                        return;
                    }
                    let modal = new MACRAIL.Modal(response);
                    if (opts.onClose) {
                        modal.setOption('onHide', function () {
                            opts.onClose();
                        });
                    }
                    GLOBALS.currentModal = modal;
                    modal.show();
                })
                    .fail(function () {
                    MACRAIL.UI.Snackbar.show('danger', errorMessage);
                });
            }
            static postToAction(screen, action, data = {}) {
                let url = Screens.urlForScreen('postToAction', screen);
                data._action = action;
                return $.post(url, data);
            }
            static postForm(screen, form) {
                let url = Screens.urlForScreen('postForm', screen);
                let data = form.getValues();
                return $.post(url, data);
            }
            static urlForScreen(task, screen) {
                let url = MACRAIL.Helpers.makeUrl({
                    'controller': 'comScreen',
                    'action': '_' + task,
                    'item': screen,
                    'params': {
                        '_specialpage': 'nohtml',
                    },
                });
                return url;
            }
        }
        Screens.lastShowTime = 0;
        UI.Screens = Screens;
    })(UI = MACRAIL.UI || (MACRAIL.UI = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Business;
    (function (Business) {
        class PostcodeService {
            static getTravelInformation(from, to, callback) {
                let cacheKey = `${from}-${to}`;
                let request;
                if (PostcodeService.cache[cacheKey]) {
                    request = PostcodeService.cache[cacheKey];
                    if (request.complete) {
                        callback(request.info);
                    }
                    else {
                        request.callbacks.push(callback);
                    }
                    return;
                }
                request = {
                    'callbacks': [
                        callback,
                    ],
                    'complete': false,
                    'info': {
                        'from': from,
                        'to': to,
                        'valid': false,
                        'distance': 0,
                        'duration': 0,
                    },
                };
                PostcodeService.cache[cacheKey] = request;
                let ajaxRequest = MACRAIL.Ajax.postController('comRegisterSignIn', '_travelInformation', {
                    'from': from,
                    'to': to,
                });
                ajaxRequest.always(function (data, status, jqXhr) {
                    request.complete = true;
                    if (status === 'success' && data.status && data.status === 'success') {
                        let info = data.message;
                        request.info.valid = true;
                        request.info.distance = info.distance;
                        request.info.duration = info.duration;
                        for (let requstCallback of request.callbacks) {
                            requstCallback(request.info);
                        }
                        request.callbacks = [];
                    }
                    else {
                        for (let requstCallback of request.callbacks) {
                            requstCallback(request.info);
                        }
                        request.callbacks = [];
                    }
                });
            }
        }
        PostcodeService.cache = [];
        Business.PostcodeService = PostcodeService;
    })(Business = MACRAIL.Business || (MACRAIL.Business = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Business;
    (function (Business) {
        class RegisterEntry {
            constructor() {
                this.timeIn = undefined;
                this.timeOut = undefined;
                this.timeLeftRest = undefined;
                this.timeReturnRest = undefined;
                this.travelIn = undefined;
                this.travelOut = undefined;
                this.onSiteWarning = undefined;
                this.onSiteDanger = undefined;
                this.doorToDoorWarning = undefined;
                this.doorToDoorDanger = undefined;
            }
            setTimeIn(newTimeIn) {
                this.timeIn = newTimeIn;
                return this;
            }
            getTimeIn() {
                return this.timeIn;
            }
            hasTimeIn() {
                return this.timeIn !== undefined;
            }
            setTimeOut(newTimeOut) {
                this.timeOut = newTimeOut;
                return this;
            }
            getTimeOut() {
                return this.timeOut;
            }
            hasTimeOut() {
                return this.timeOut !== undefined;
            }
            setTimeLeftRest(newTimeLeftRest) {
                this.timeLeftRest = newTimeLeftRest;
                return this;
            }
            hasTimeLeftRest() {
                return this.getTimeLeftRest() !== undefined;
            }
            getTimeLeftRest() {
                if (this.timeLeftRest !== undefined) {
                    return this.timeLeftRest;
                }
                if (this.timeIn !== undefined && this.travelIn !== undefined) {
                    return new Date(this.timeIn.getTime() - this.travelIn);
                }
                return undefined;
            }
            setTimeReturnRest(newTimeReturnRest) {
                this.timeReturnRest = newTimeReturnRest;
                return this;
            }
            hasTimeReturnRest() {
                return this.getTimeReturnRest() !== undefined;
            }
            getTimeReturnRest() {
                if (this.timeReturnRest !== undefined) {
                    return this.timeReturnRest;
                }
                if (this.timeOut !== undefined && this.travelOut !== undefined) {
                    return new Date(this.timeOut.getTime() + this.travelOut);
                }
                return undefined;
            }
            setTravelIn(newTravelIn) {
                this.travelIn = newTravelIn;
                return this;
            }
            hasTravelIn() {
                return this.getTravelIn() !== undefined;
            }
            getTravelIn() {
                if (this.travelIn !== undefined) {
                    return this.travelIn;
                }
                if (this.timeIn !== undefined && this.timeLeftRest !== undefined) {
                    let travel = this.timeIn.getTime() - this.timeLeftRest.getTime();
                    if (travel >= 0) {
                        return travel;
                    }
                }
                return undefined;
            }
            setTravelOut(newTravelOut) {
                this.travelOut = newTravelOut;
                return this;
            }
            hasTravelOut() {
                return this.getTravelOut !== undefined;
            }
            getTravelOut() {
                if (this.travelOut !== undefined) {
                    return this.travelOut;
                }
                if (this.timeOut !== undefined && this.timeReturnRest !== undefined) {
                    let travel = this.timeReturnRest.getTime() - this.timeOut.getTime();
                    if (travel >= 0) {
                        return travel;
                    }
                }
                return undefined;
            }
            setOnSiteWarning(newOnSiteWarning) {
                this.onSiteWarning = newOnSiteWarning;
                return this;
            }
            hasOnSiteWarning() {
                return this.onSiteWarning !== undefined;
            }
            getOnSiteWarning() {
                return this.onSiteWarning;
            }
            setOnSiteDanger(newOnSiteDanger) {
                this.onSiteDanger = newOnSiteDanger;
                return this;
            }
            hasOnSiteDanger() {
                return this.onSiteDanger !== undefined;
            }
            getOnSiteDanger() {
                return this.onSiteDanger;
            }
            setDoorToDoorWarning(newDoorToDoorWarning) {
                this.doorToDoorWarning = newDoorToDoorWarning;
                return this;
            }
            hasDoorToDoorWarning() {
                return this.doorToDoorWarning !== undefined;
            }
            getDoorToDoorWarning() {
                return this.doorToDoorWarning;
            }
            setDoorToDoorDanger(newDoorToDoorDanger) {
                this.doorToDoorDanger = newDoorToDoorDanger;
                return this;
            }
            hasDoorToDoorDanger() {
                return this.doorToDoorDanger !== undefined;
            }
            getDoorToDoorDanger() {
                return this.doorToDoorDanger;
            }
            hasOnSiteDuration() {
                return this.hasTimeIn() && this.hasTimeOut();
            }
            getOnSiteDuration() {
                if (this.timeIn === undefined || this.timeOut === undefined) {
                    return undefined;
                }
                return this.timeOut.getTime() - this.timeIn.getTime();
            }
            hasDoorToDoorDuration() {
                return this.hasTimeLeftRest() && this.hasTimeReturnRest();
            }
            getDoorToDoorDuration() {
                let timeLeftRest = this.getTimeLeftRest();
                let timeReturnRest = this.getTimeReturnRest();
                if (timeLeftRest === undefined || timeReturnRest === undefined) {
                    return undefined;
                }
                return timeReturnRest.getTime() - timeLeftRest.getTime();
            }
            getMustLeaveByForOnSiteRule() {
                if (this.timeIn === undefined || this.onSiteDanger === undefined) {
                    return undefined;
                }
                return new Date(this.timeIn.getTime() + this.onSiteDanger);
            }
            getMustLeaveByForDoorToDoorRule() {
                let timeLeftRest = this.getTimeLeftRest();
                let travelOut = this.getTravelOut() || 0;
                if (!timeLeftRest || this.doorToDoorDanger === undefined) {
                    return undefined;
                }
                return new Date(timeLeftRest.getTime() - travelOut + this.doorToDoorDanger);
            }
            isOverOnSiteWarning() {
                let duration = this.getOnSiteDuration();
                if (duration && this.onSiteWarning && duration > this.onSiteWarning) {
                    return true;
                }
                return false;
            }
            isOverOnSiteDanger() {
                let duration = this.getOnSiteDuration();
                if (duration && this.onSiteDanger && duration > this.onSiteDanger) {
                    return true;
                }
                return false;
            }
            isOverDoorToDoorWarning() {
                let duration = this.getDoorToDoorDuration();
                if (duration && this.doorToDoorWarning && duration > this.doorToDoorWarning) {
                    return true;
                }
                return false;
            }
            isOverDoorToDoorDanger() {
                let duration = this.getDoorToDoorDuration();
                if (duration && this.doorToDoorDanger && duration > this.doorToDoorDanger) {
                    return true;
                }
                return false;
            }
        }
        Business.RegisterEntry = RegisterEntry;
    })(Business = MACRAIL.Business || (MACRAIL.Business = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Sockets;
    (function (Sockets) {
        class SocketHelper {
            constructor(io) {
                this.io = io;
                return this;
            }
            connect(callback) {
                let self = this;
                this.io.on('connect', function () {
                    self.connected = true;
                    callback(self);
                });
                return this;
            }
            emit(command, params) {
                this.io.emit(command, Object.assign({
                    'room': this.room,
                }, params));
            }
            on(command, callback) {
                this.io.on(command, callback);
            }
            isConnected() {
                return this.connected;
            }
            getCurrentRoom() {
                return this.room;
            }
            joinRoom(room, random = false) {
                this.room = this.generateSocketRoom(room, random);
                this.io.emit('join_room', this.room);
            }
            generateSocketRoom(room, random = false) {
                if (random) {
                    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 6) + '-' + room;
                }
                return room;
            }
        }
        Sockets.SocketHelper = SocketHelper;
    })(Sockets = MACRAIL.Sockets || (MACRAIL.Sockets = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var UI;
    (function (UI) {
        class Menu extends MACRAIL.EventEmitter {
            constructor(opts) {
                super();
                opts.itemSelector = opts.itemSelector || 'tr';
                this.opts = opts;
                this.qTip = MACRAIL.Helpers.createQtip({
                    'target': opts.element,
                    'position': 'below',
                    'class': 'info',
                    'extraClasses': 'qtip-menu',
                    'title': '',
                    'content': opts.content,
                });
                this.opts.element.on('click', opts.targetClass, (e) => {
                    let $button = $(e.currentTarget);
                    this.selectedItem = $button.closest(this.opts.itemSelector);
                    let selectedId = this.selectedItem.data('id');
                    let selectedIsEditable = this.selectedItem.data('editable');
                    this.qTip.hide();
                    this.qTip.set('position.target', $button);
                    this.opts.content.find('a').each(function (i, el) {
                        let $el = $(el);
                        let href = $el.data('href');
                        if (href) {
                            href = href.replace('{id}', selectedId);
                            $el.attr('href', href);
                        }
                    });
                    this.opts.content.find('li[data-menu-name="edit"]')[!selectedIsEditable ? 'hide' : 'show']();
                    this.opts.content.find('li[data-menu-name="audit-history"]')[!selectedIsEditable ? 'hide' : 'show']();
                    this.opts.content.find('li.divider')[!selectedIsEditable ? 'hide' : 'show']();
                    this.qTip.show();
                    let event = {
                        'selectedItem': this.selectedItem,
                        'jQueryEvent': e,
                    };
                    this.trigger('opened', event);
                });
                this.opts.content.on('click', 'li', (e) => {
                    let name = $(e.currentTarget).data('menu-name');
                    let event = {
                        'name': name,
                        'selectedItem': this.selectedItem,
                        'jQueryEvent': e,
                    };
                    this.trigger('itemclick', event);
                    this.trigger('itemclick', name, event);
                    this.qTip.hide();
                });
            }
            getQTip() {
                return this.qTip;
            }
        }
        UI.Menu = Menu;
    })(UI = MACRAIL.UI || (MACRAIL.UI = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var UI;
    (function (UI) {
        class QrCode {
            static show(rootElement, file) {
                let name = rootElement.dataset.qrcodeName;
                let data = rootElement.dataset.qrcodeContent;
                let body = $(`
            <div id="qrcode-modal-content" style="text-align: center;">
                <p>Scan this QR Code with your mobile to view.</p>
            </div>
        `);
                let qrCodeDiv = $(`<div style="margin: 20px; text-align: center;"></div>`);
                body.append(qrCodeDiv);
                if (data.substring(0, 4) == 'http') {
                    body.append('<p style="margin: 20px;"><a target="_blank" href="' + data + '">Open link</a></p>');
                }
                if (name) {
                    let downloadBtn = $('<button class="btn btn-primary">Download</button>');
                    let downloadP = $(`<p></p>`).append(downloadBtn);
                    body.append(downloadP);
                    downloadBtn.on('click', function () {
                        var dataUrl = qrCodeDiv.find('canvas')[0].toDataURL();
                        var anchor = document.createElement('a');
                        anchor.href = dataUrl;
                        anchor.download = 'QR Code - ' + name.replace(/[^a-zA-z0-9 -\(\)]/g, '');
                        anchor.click();
                        anchor.remove();
                    });
                }
                let title = 'QR Code';
                if (name) {
                    title += ': ' + name;
                }
                let qrCodeModal = new MACRAIL.Modal({
                    'id': 'qrcode-modal',
                    'title': title,
                    'body': body,
                    'buttons': MACRAIL.Modal.defaultButtonGroups.close,
                    'destroyOnClose': true,
                });
                new QRCode(qrCodeDiv[0], data);
                setTimeout(function () {
                    qrCodeDiv.find('img').css('display', '');
                }, 1);
                qrCodeModal.show();
            }
        }
        UI.QrCode = QrCode;
    })(UI = MACRAIL.UI || (MACRAIL.UI = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Validation;
    (function (Validation) {
        class CustomFunctionValidator {
            constructor(opts) {
                if (typeof opts === 'function') {
                    opts = {
                        'callback': opts,
                    };
                }
                opts.extraData = opts.extraData || {};
                this.opts = opts;
            }
            validate(value) {
                let opts = this.opts;
                let messages = [];
                function addMessage(status, message) {
                    messages.push({
                        'slug': 'custom',
                        'status': status,
                        'message': message,
                    });
                }
                this.opts.callback(value, addMessage, this.opts.extraData);
                return messages;
            }
        }
        Validation.CustomFunctionValidator = CustomFunctionValidator;
    })(Validation = MACRAIL.Validation || (MACRAIL.Validation = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Validation;
    (function (Validation) {
        class FileValidator {
            constructor(opts) {
                this.opts = opts;
            }
            validate(value) {
                let opts = this.opts;
                let messages = [];
                if (!value) {
                    return messages;
                }
                if (opts.validExtensions !== undefined) {
                    if (value.type !== undefined && opts.validExtensions.indexOf(value.type) === -1) {
                        messages.push({
                            'slug': 'file',
                            'status': 'error',
                            'message': opts.invalidMessage || 'File Type is not allowed',
                        });
                    }
                }
                if (opts.invalidExtensions !== undefined) {
                    if (value.type !== undefined && opts.validExtensions.indexOf(value.type) >= 0) {
                        messages.push({
                            'slug': 'file',
                            'status': 'error',
                            'message': opts.invalidMessage || 'File Type is not allowed',
                        });
                    }
                }
                return messages;
            }
        }
        Validation.FileValidator = FileValidator;
    })(Validation = MACRAIL.Validation || (MACRAIL.Validation = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Validation;
    (function (Validation) {
        class LengthValidator {
            constructor(opts) {
                this.opts = opts;
            }
            validate(value) {
                let opts = this.opts;
                let len = value.length;
                let messages = [];
                if (opts.minLengthError && len < opts.minLengthError) {
                    messages.push({
                        'slug': 'length',
                        'status': 'error',
                        'message': `Must be at least ${opts.minLengthError} characters.`,
                    });
                }
                else if (opts.minLengthWarning && len < opts.minLengthWarning) {
                    messages.push({
                        'slug': 'length',
                        'status': 'warning',
                        'message': `Should be at least ${opts.minLengthWarning} characters.`,
                    });
                }
                if (opts.maxLengthError && len > opts.maxLengthError) {
                    messages.push({
                        'slug': 'length',
                        'status': 'error',
                        'message': `Must be ${opts.maxLengthError} characters or fewer.`,
                    });
                }
                else if (opts.maxLengthWarning && len < opts.maxLengthWarning) {
                    messages.push({
                        'slug': 'length',
                        'status': 'warning',
                        'message': `Should be ${opts.maxLengthWarning} characters or fewer.`,
                    });
                }
                return messages;
            }
        }
        Validation.LengthValidator = LengthValidator;
    })(Validation = MACRAIL.Validation || (MACRAIL.Validation = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Validation;
    (function (Validation) {
        class NumberValidator {
            constructor(opts) {
                this.opts = opts;
            }
            validate(value) {
                let opts = this.opts;
                let messages = [];
                if (typeof value !== 'number' && !('' + value).match(/\d+/) &&
                    (opts.optional === undefined || opts.optional === false)) {
                    messages.push({
                        'slug': 'number',
                        'status': 'error',
                        'message': opts.invalidMessage || `Enter a number`,
                    });
                }
                let num = parseInt(value, 10);
                if (opts.minError && num < opts.minError) {
                    messages.push({
                        'slug': 'number',
                        'status': 'error',
                        'message': opts.errorMessage || `Must be at least ${opts.minError}.`,
                    });
                }
                else if (opts.minWarning && num < opts.minWarning) {
                    messages.push({
                        'slug': 'number',
                        'status': 'warning',
                        'message': opts.warningMessage || `Should be at least ${opts.minWarning}.`,
                    });
                }
                if (opts.maxError && num > opts.maxError) {
                    messages.push({
                        'slug': 'number',
                        'status': 'error',
                        'message': opts.errorMessage || `Must be ${opts.maxError} or less.`,
                    });
                }
                else if (opts.maxWarning && num > opts.maxWarning) {
                    messages.push({
                        'slug': 'number',
                        'status': 'warning',
                        'message': opts.warningMessage || `Should be ${opts.maxWarning} or less.`,
                    });
                }
                return messages;
            }
        }
        Validation.NumberValidator = NumberValidator;
    })(Validation = MACRAIL.Validation || (MACRAIL.Validation = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Validation;
    (function (Validation) {
        class PostcodeValidator {
            constructor(opts) {
                this.postCodeRegex = /^(((([A-PR-UWYZ][A-HK-Y]?[0-9][0-9]?)|(([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRV-Y]))) [0-9][ABD-HJLNP-UW-Z]{2}))$/i;
                this.postCodeShortRegex = /^(([A-PR-UWYZ][A-HK-Y]?[0-9][0-9]?)|(([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRV-Y])))$/i;
                this.eircodeRegex = /^([AC-FHKNPRTV-Y]{1}[0-9]{2}|D6W)[ ]?[0-9AC-FHKNPRTV-Y]{4}$/i;
                this.opts = opts;
                this.opts.allowShort = this.opts.allowShort || true;
            }
            validate(value) {
                let opts = this.opts;
                if (value.length === 0) {
                    return [];
                }
                let messages = [];
                if (this.postCodeShortRegex.test(value)) {
                    if (!this.opts.allowShort) {
                        messages.push({
                            'slug': 'short',
                            'status': 'error',
                            'message': `Enter a full postcode.`,
                        });
                    }
                }
                else {
                    if (!this.postCodeRegex.test(value)) {
                        if (!this.eircodeRegex.test(value)) {
                            messages.push({
                                'slug': 'format',
                                'status': 'error',
                                'message': `Does not appear to be a valid postcode.`,
                            });
                        }
                    }
                }
                return messages;
            }
        }
        Validation.PostcodeValidator = PostcodeValidator;
    })(Validation = MACRAIL.Validation || (MACRAIL.Validation = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Validation;
    (function (Validation) {
        class RequiredValidator {
            constructor(opts) {
                this.opts = opts || {};
                if (!this.opts.message) {
                    this.opts.message = 'Please enter a value';
                }
            }
            validate(value) {
                let opts = this.opts;
                let messages = [];
                if (value === undefined || value === '') {
                    messages.push({
                        'slug': 'required',
                        'status': 'error',
                        'message': this.opts.message,
                    });
                }
                return messages;
            }
        }
        Validation.RequiredValidator = RequiredValidator;
    })(Validation = MACRAIL.Validation || (MACRAIL.Validation = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Validation;
    (function (Validation) {
        class ValueValidator {
            constructor(opts) {
                this.opts = opts;
                this.opts.status = this.opts.status || 'warning';
            }
            validate(value) {
                let messages = [];
                if (value === undefined) {
                    return messages;
                }
                if (this.opts.states[value]) {
                    messages.push({
                        'slug': 'value',
                        'status': this.opts.status,
                        'message': this.opts.states[value],
                    });
                }
                return messages;
            }
        }
        Validation.ValueValidator = ValueValidator;
    })(Validation = MACRAIL.Validation || (MACRAIL.Validation = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class AutoComplete extends Fields.BaseField {
                constructor(element, optsPartial) {
                    super(element, optsPartial);
                    this.valueForHumans = '';
                    this.valueForHumansSelected = '';
                    this.settingValue = false;
                    const defaultOpts = {
                        highlightTerm: true,
                        mappingSource: [],
                        mappingValue: 'id',
                        mappingValueForHumans: 'value',
                        maxItems: 30,
                        minLength: 2,
                        source: undefined,
                        _renderItem: this.renderItem,
                    };
                    let opts = Object.assign({}, defaultOpts, optsPartial);
                    this.opts = opts;
                    const pageVarName = 'autocomplete_' + this.element.attr('name') + '_' + this.element.data('rand-id');
                    if (!opts.source || opts.source.length == 0) {
                        if (PAGEVARS[pageVarName + '_items']) {
                            opts.mappingSource = PAGEVARS[pageVarName + '_items'];
                        }
                    }
                    if (!opts.otherId) {
                        opts.otherId = this.element.data('other-id');
                    }
                    let options = {
                        'source': opts.source || this.getItems.bind(this),
                        'select': (event, ui) => {
                            this.value = ui.item[this.opts.mappingValue];
                            let valueForHumans = ui.item[this.opts.mappingValueForHumans];
                            this.valueForHumans = valueForHumans;
                            this.valueForHumansSelected = valueForHumans;
                            this.element.blur();
                            this.element.trigger('change');
                            if (this.opts.onSelect) {
                                this.opts.onSelect(event, ui);
                            }
                        },
                    };
                    if (opts.delay) {
                        options.delay = opts.delay;
                    }
                    if (opts.hasOwnProperty('minLength')) {
                        options.minLength = opts.minLength;
                    }
                    this.element.autocomplete(options);
                    if (this.element.data('value')) {
                        this.setValue(this.element.data('value'));
                    }
                    if (opts.openOnFocus || opts.selectTextOnFocus) {
                        this.element.on('focus', (e) => {
                            if (this.opts.openOnFocus) {
                                this.element.autocomplete('search', '');
                            }
                            if (this.opts.selectTextOnFocus) {
                                this.element[0].select();
                            }
                        });
                    }
                    if (opts._renderItem) {
                        this.element.data('ui-autocomplete')._renderItem = opts._renderItem;
                    }
                    this.element.on('blur', (e) => {
                        if (this.element.val() !== this.valueForHumansSelected) {
                            this.element.val(this.valueForHumansSelected);
                        }
                    });
                }
                getItems(request, response) {
                    let items = [];
                    let otherItem = undefined;
                    let otherItemShown = false;
                    let term = request.term.toLowerCase();
                    if (term.length < this.opts.minLength) {
                        if (this.opts.mappingSource.length <= this.opts.maxItems) {
                            for (let i = 0; i < this.opts.mappingSource.length; i++) {
                                items.push(this.opts.mappingSource[i]);
                            }
                        }
                    }
                    else {
                        for (let i = 0; i < this.opts.mappingSource.length; i++) {
                            let item = this.opts.mappingSource[i];
                            if (item[this.opts.mappingValueForHumans].toLowerCase().indexOf(term) > -1) {
                                items.push(item);
                                if (item[this.opts.mappingValue] === this.opts.otherId) {
                                    otherItemShown = true;
                                }
                            }
                            if (item[this.opts.mappingValue] == this.opts.otherId) {
                                otherItem = item;
                            }
                        }
                    }
                    items.sort((a, b) => {
                        let labelA = a[this.opts.mappingValueForHumans].toLowerCase();
                        let labelB = b[this.opts.mappingValueForHumans].toLowerCase();
                        if (labelA === term)
                            return -1;
                        if (labelB === term)
                            return 1;
                        let indexOfA = labelA.indexOf(term);
                        let indexOfB = labelB.indexOf(term);
                        if (indexOfA === 0 && indexOfB !== 0)
                            return -1;
                        if (indexOfB === 0 && indexOfA !== 0)
                            return 1;
                        if (labelA < labelB)
                            return -1;
                        if (labelA > labelB)
                            return 1;
                        return 0;
                    });
                    while (items.length > this.opts.maxItems) {
                        items.pop();
                    }
                    if (otherItem && !otherItemShown) {
                        if (items.length == this.opts.maxItems) {
                            items.pop();
                        }
                        items.push(otherItem);
                    }
                    response(items);
                }
                renderItem(ul, item) {
                    let li = $('<li>');
                    let div = $('<div>');
                    li.append(div);
                    let termRegex = new RegExp($.ui.autocomplete.escapeRegex(this.term), 'i');
                    div.append(item.value.replace(termRegex, '<span class="hilite">$&</span>'));
                    if (item.extra && item.extra != '') {
                        div.append('<span class="extra">' + item.extra + '</span>');
                    }
                    return li.appendTo(ul);
                }
                setValue(newValue) {
                    if (newValue === undefined) {
                        this.value = undefined;
                        this.setValueForHumans('');
                        this.setDirty(true);
                        this.element.trigger('change');
                        return;
                    }
                    if (this.opts.mappingSource) {
                        let mappingSource = this.opts.mappingSource;
                        let mappingValue = this.opts.mappingValue;
                        for (let item of mappingSource) {
                            if (item[mappingValue] === newValue) {
                                this.value = newValue;
                                this.setValueForHumans(item[this.opts.mappingValueForHumans]);
                                this.setDirty(true);
                                this.element.trigger('change');
                                if (this.opts.onSelect && !this.settingValue) {
                                    this.settingValue = true;
                                    try {
                                        this.opts.onSelect(new Event('change'), { item });
                                    }
                                    finally {
                                        this.settingValue = false;
                                    }
                                }
                                return;
                            }
                        }
                    }
                    else {
                        super.setValue(newValue);
                    }
                }
                getValueForHumans() {
                    return this.valueForHumans;
                }
                setValueForHumans(valueForHumans) {
                    this.valueForHumans = valueForHumans;
                    this.valueForHumansSelected = valueForHumans;
                    this.element.val(this.valueForHumans);
                }
                setValues(value, valueForHumans) {
                    this.value = value;
                    this.setDirty(true);
                    this.element.trigger('change');
                    this.setValueForHumans(valueForHumans);
                }
            }
            Fields.AutoComplete = AutoComplete;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class ConfirmAlert extends Fields.BaseField {
                constructor(element, opts) {
                    opts.defaultValue = opts.defaultValue || 0;
                    super(element, opts);
                    this.alert = opts.alert;
                    this.element.on('confirmalert-statechange', () => {
                        this.element.trigger('fieldchanged');
                    });
                    this.element.find('.btn').on('click', () => {
                        this.setDirty(true);
                    });
                }
                getValue() {
                    return this.alert.getState();
                }
            }
            Fields.ConfirmAlert = ConfirmAlert;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class MultipleChoice extends Fields.BaseField {
                constructor(element) {
                    super(element);
                    let self = this;
                    this.element.on('click', '.remove-item', function (el) {
                        if (self.element.find('tbody tr').length == 1) {
                            alert('You cannot remove the last item.');
                            return;
                        }
                        let tr = $(this).closest('tr');
                        let itemText = tr.find('textarea').val();
                        if (confirm('Are you sure you want to remove the below item?\n\n' + itemText)) {
                            tr.remove();
                        }
                    });
                    this.element.find('.add-item').on('click', function () {
                        let tbody = self.element.find('tbody');
                        let lastTr = tbody.find('tr:last-child');
                        let newTr = lastTr.clone();
                        newTr.find('textarea').val('');
                        tbody.append(newTr);
                    });
                }
                getValue() {
                    let value = [];
                    this.element.find('textarea').each(function (i, el) {
                        value.push(el.value);
                    });
                    return JSON.stringify(value);
                }
            }
            Fields.MultipleChoice = MultipleChoice;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class Otherable extends Fields.BaseField {
                constructor(element, opts = {}) {
                    super(element, opts);
                    this.addedOther = false;
                    this.otherCount = 0;
                    this.popupOpen = false;
                    this.element.on('change', (e) => {
                        this.updateValueElement();
                    });
                }
                addOption(id, label) {
                    this.element.hide();
                    let elementId = this.element.prop('id');
                    if (!this.addedOther) {
                        this.addedOther = true;
                        this.valueElement = $(`
                <div class="otherable-value form-control">
                    <span></span>
                    <i class="fa fa-caret-down"></i>
                </div>
            `);
                        this.valueElement.insertBefore(this.element);
                        this.updateValueElement();
                        this.valueElement.on('click', () => {
                            if (this.popupOpen) {
                                this.qTip.show();
                            }
                            else {
                                this.qTip.show();
                            }
                        });
                        this.otherContainer = $('<div class="boxset"></div>');
                        this.otherContainer.insertBefore(this.element);
                        this.otherLabel = $(`<label for="${elementId}-other">` +
                            `<input type="radio" id="${elementId}-other" name="${elementId}-others" /> ` +
                            `Other` +
                            `</label>`);
                        this.otherContainer.append(this.otherLabel);
                        this.otherLabel.on('click', (e) => {
                            if (e.target.tagName !== 'LABEL' && e.target.type !== 'radio') {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        });
                        this.otherLabel.append(this.element);
                        this.otherContainer.hide();
                        this.otherContainer.on('click', 'input[type="radio"]', (e) => {
                            const input = $(e.currentTarget);
                            const labelElement = input.parent();
                            this.otherContainer.find('label').removeClass('active');
                            labelElement.addClass('active');
                            let newValue = input.data('value');
                            if (newValue !== undefined) {
                                this.setElementValue(newValue);
                                this.element.hide();
                                this.element.trigger('change');
                            }
                            else {
                                newValue = this.element.find('option:first-child').val();
                                this.element.val(newValue);
                                this.value = newValue;
                                this.element.show();
                                if (this.element.attr('type') === 'text') {
                                    this.element.focus();
                                }
                            }
                            this.updateValueElement();
                            if (!labelElement.is(':last-child')) {
                                setTimeout(() => {
                                    this.qTip.hide();
                                }, 200);
                            }
                        });
                        this.qTip = MACRAIL.Helpers.createQtip({
                            'content': this.otherContainer,
                            'position': 'below',
                            'target': this.valueElement,
                        });
                    }
                    this.otherLabel.before(`<label for="${elementId}-${this.otherCount}">` +
                        `<input type="radio" id="${elementId}-${this.otherCount}" data-value="${id}" name="${elementId}-others" /> ` +
                        `${label}` +
                        `</label>`);
                    this.otherCount++;
                }
                clearOptions() {
                    if (!this.otherContainer) {
                        return;
                    }
                    this.valueElement
                        .parent()
                        .append(this.element);
                    this.otherContainer.remove();
                    this.otherContainer = undefined;
                    this.otherLabel = undefined;
                    this.valueElement.remove();
                    this.valueElement = undefined;
                    this.element.show();
                    this.addedOther = false;
                    this.otherCount = 0;
                    this.qTip.destroy(true);
                }
                setValue(newValue) {
                    if (newValue === this.element.val()) {
                        return;
                    }
                    if (newValue === undefined) {
                        this.setElementValue(this.defaultValue);
                        if (this.addedOther) {
                            this.otherContainer.parent()
                                .find('input:checked')
                                .prop('checked', false)
                                .parent()
                                .removeClass('active');
                            this.element.hide();
                        }
                    }
                    else {
                        let foundInOthers = false;
                        if (this.addedOther) {
                            let input = this.otherContainer.find('input[data-value="' + newValue + '"]');
                            if (input.length === 1) {
                                input.trigger('click');
                                foundInOthers = true;
                            }
                        }
                        if (!foundInOthers) {
                            if (this.otherLabel) {
                                this.otherLabel.find('[type="radio"]').trigger('click');
                            }
                            this.element.val(newValue);
                        }
                    }
                    this.value = newValue;
                    this.updateValueElement();
                    this.setDirty(true);
                }
                getValue() {
                    let val = this.element.val();
                    if (val === '-1') {
                        return undefined;
                    }
                    return val;
                }
                reset() {
                    super.reset();
                    this.clearOptions();
                }
                setElementValue(newValue) {
                    if (this.element.is('select') && newValue === undefined) {
                        newValue = -1;
                    }
                    let oldValue = this.element.val();
                    this.element.val(newValue);
                    this.value = newValue;
                    if (this.element.is('select') && this.element.val() === null) {
                        this.element.val(oldValue);
                        this.value = oldValue;
                        console.error(`Otherable '${this.name}' tried to set the value '${newValue}' which doesn't exist.`);
                    }
                    this.updateValueElement();
                }
                updateValueElement() {
                    if (!this.addedOther) {
                        return;
                    }
                    let value = '';
                    if (this.element.is('select')) {
                        value = this.element.find('option:checked').text();
                    }
                    else {
                        value = this.element.val();
                    }
                    this.valueElement.find('span').text(value);
                }
            }
            Fields.Otherable = Otherable;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class Password extends Fields.BaseField {
                constructor(element, opts = {}) {
                    super(element, opts);
                    let self = this;
                    this.element.find('button').on('click', () => {
                        let input = this.getInput();
                        let button = this.element.find('button');
                        switch (input.attr('type')) {
                            case 'password':
                                input.attr('type', 'text');
                                button.html('<i class="fa fa-eye-slash"></i> Hide');
                                break;
                            case 'text':
                                input.attr('type', 'password');
                                button.html('<i class="fa fa-eye"></i> Show');
                                break;
                        }
                    });
                }
                getValue() {
                    return this.getInput().val();
                }
                setValue(newValue) {
                    this.getInput().val(newValue);
                }
                getInput() {
                    return this.element.find('input');
                }
            }
            Fields.Password = Password;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));
var MACRAIL;
(function (MACRAIL) {
    var Forms;
    (function (Forms) {
        var Fields;
        (function (Fields) {
            class SingleUpload extends Fields.BaseField {
                constructor(element, opts = {}) {
                    super(element, opts);
                    let self = this;
                    this.element.parents('.btn-file').find(':file').on('fileselect', function (event, numFiles, label) {
                        let input = $(this).parents('.input-group').find(':text');
                        if (input.length) {
                            input.val(label);
                        }
                    });
                }
                getFile() {
                    return this.element.prop('files')[0];
                }
                getValue() {
                    let thumbElement = this.getThumbnailElement();
                    if (thumbElement) {
                        let src = thumbElement.getAttribute("src");
                        if (src.length > 42) {
                            return src;
                        }
                        return null;
                    }
                    return this.element.prop('files')[0];
                }
                reset() {
                    super.reset();
                    this.element[0].value = '';
                    this.getThumbnailElement().src = '';
                }
                getThumbnailElement() {
                    return document.getElementById(this.name + '-thumbnail');
                }
            }
            Fields.SingleUpload = SingleUpload;
        })(Fields = Forms.Fields || (Forms.Fields = {}));
    })(Forms = MACRAIL.Forms || (MACRAIL.Forms = {}));
})(MACRAIL || (MACRAIL = {}));

//# sourceMappingURL=javascript.js.map
